// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-24T16:58:38.986Z
// Property: Pinnacle Heights (ID: 6767906449166446)
// Collections: 26 amenities, 15 floorplans (live), 23 photos, 55 POIs, 5 reviews, 6 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5742705921490944",
  "multihub_property_id": "6767906449166446",
  "property_external_id": "dlemb7l",
  "property_zillow_url": "https://www.zillow.com/apartments/tucson-az/pinnacle-heights/5XhzJz/",
  "property_apartments_url": "https://www.apartments.com/pinnacle-heights-tucson-az/dlemb7l/",
  "property_google_business_url": "https://www.google.com/maps/place/Pinnacle+Heights+Apartment+Homes/data=!4m2!3m1!1s0x0:0xdff1534fff22102b?sa=X&ved=2ahUKEwj9_fjv46eSAxVUrpUCHYy1KgQQ_BJ6BAgJEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "40254249088",
  "property_crm_software": "Anyone Home",
  "property_pm_software": "AIM",
  "property_pm_info": "94PHT",
  "property_status": null,
  "property_slug": "pinnacle-heights",
  "property_name": "Pinnacle Heights",
  "property_website_url": "http://www.pinnacleheightsapts.com/",
  "property_domain": "https://www.pinnacleheightsapts.com/",
  "property_address": "7990 East Snyder Road",
  "property_full_address": "7990 E Snyder Rd, Tucson, AZ 85750",
  "property_address_1": "7990 E Snyder Rd",
  "property_address_2": null,
  "property_address_city": "Tucson",
  "property_address_state": "AZ",
  "property_address_zip_full": null,
  "property_address_zip": "85750",
  "property_address_country": "US",
  "property_address_county": "Pima County",
  "property_neighborhood_address": "Sabino Terrace",
  "property_address_latitude": "32.2919387",
  "property_address_longitude": "-110.8206467",
  "property_email": null,
  "property_phone": "(888) 292-0988",
  "property_call_tracking_phone": "844-888-1764",
  "property_company_name": "Apartment Management Consultants",
  "property_company_url": "https://www.liveamc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At Pinnacle Heights in Tucson, AZ, luxury meets comfort. Choose from one, two, or three-bedroom floor plans featuring stunning mountain views, spacious layouts, and modern amenities like a resort-style pool, fitness center, and a cozy clubhouse. Ready to elevate your lifestyle? Browse our availability or schedule a tour today!",
  "property_long_description": "**Discover Pinnacle Heights: Your Ideal Tucson Oasis**\n\nWelcome to Pinnacle Heights, where comfort meets luxury in the heart of Tucson, AZ. Our stunning apartment community offers an array of spacious floor plans, including one, two, and three-bedroom options to fit your lifestyle perfectly. Each newly renovated apartment features exquisite quartz countertops, E-STAR stainless steel appliances, and inviting wood-burning fireplaces, providing the perfect blend of style and functionality.\n\nExperience unparalleled amenities designed for relaxation and convenience. Unwind in our newly renovated resort-style swimming pool and spa or enjoy outdoor moments in our picnic area equipped with gas grills. For fitness enthusiasts, our state-of-the-art fitness center and dedicated yoga/spin room will exceed your expectations. Connecting with friends over a complimentary cup of coffee at our relaxing clubhouse has never been easier, and with 24-hour emergency maintenance and online payment services, we prioritize your comfort and peace of mind.\n\nEnjoy breathtaking mountain views from your large private patio or balcony, and take advantage of the spacious walk-in closets and central AC for your convenience. For those who need quick and secure package deliveries, our 24-hour Amazon parcel lockers have you covered. \n\nAt Pinnacle Heights, we pride ourselves on offering property-wide fiber optic internet, reserved covered parking, and optional detached garages for all residents.\n\nDon't miss your chance to make Pinnacle Heights your new home! Browse our availability or schedule a tour today to experience the vibrant lifestyle waiting for you in Tucson. Your dream apartment is just a click away!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f66a6-fdbf-7649-9f0e-8d6c02fb004c.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool and lounge area with palm trees and apartment buildings.",
    "public_id": "019f66a6-fdbf-7649-9f0e-8d6c02fb004c",
    "storage_key": "property/6767906449166446/019f66a6-fdbf-7649-9f0e-8d6c02fb004c.webp",
    "width": 1920,
    "height": 1280
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166446/019ffc3b-0bd9-74fc-82f6-9ef7abb2a1ff.m4v",
  "property_featured_video_media": {
    "public_id": "019ffc3b-0bd9-74fc-82f6-9ef7abb2a1ff",
    "storage_key": "property/6767906449166446/019ffc3b-0bd9-74fc-82f6-9ef7abb2a1ff.m4v",
    "thumbnail_key": "property/6767906449166446/019ffc3b-0bd9-74fc-82f6-9ef7abb2a1ff_thumb.webp",
    "size_bytes": 19373452,
    "classification": "Community",
    "title": "Explore Our Vibrant Apartment Community and Amenities",
    "description": "Discover our apartment community, featuring a sparkling pool, state-of-the-art gym, and stylish interiors. Your new home awaits!"
  },
  "property_total_units": "310",
  "property_year_built": "1995",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "88.38709677419355",
  "property_admin_fee": null,
  "property_application_fee": "71.95",
  "property_fees_deposit_info": "Security Deposit\n$350-1 Month's Rent",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": null,
  "property_pet_restrictions": "Breed restrictions apply. Limit of 2 pets per home.",
  "property_pet_policy_description": "Pets welcome upon approval. Breed restrictions apply. Limit of 2 pets per home. Non‑refundable fee: $350 for one pet, $500 for two pets. Monthly pet fee: $35 for one pet, $50 for two pets.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://pinnacleheights.goprisma.com/auth/login",
  "property_apply_now_url": "https://www.myrentalapplication.com/index/amcpinnacleheights",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-9949-7464-8087-7b5e0b50e8af.webp",
  "property_primary_logo_media": {
    "alt_text": "Pinnacle Heights Apartments logo",
    "public_id": "019d02ce-9949-7464-8087-7b5e0b50e8af",
    "storage_key": "property/6767906449166446/019d02ce-9949-7464-8087-7b5e0b50e8af.webp",
    "width": 332,
    "height": 95
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-8302-75dd-b9f5-2cc0a62e8676.webp",
  "property_secondary_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02ce-8302-75dd-b9f5-2cc0a62e8676",
    "storage_key": "property/6767906449166446/019d02ce-8302-75dd-b9f5-2cc0a62e8676.webp",
    "width": 325,
    "height": 131
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-a700-746c-9c69-68b3eb4046b6.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Pinnacle Heights Apartments logo.",
    "public_id": "019d02ce-a700-746c-9c69-68b3eb4046b6",
    "storage_key": "property/6767906449166446/019d02ce-a700-746c-9c69-68b3eb4046b6.webp",
    "width": 332,
    "height": 95
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-9949-7464-8087-7b5e0b50e8af.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Pinnacle Heights Apartments logo",
    "public_id": "019d02ce-9949-7464-8087-7b5e0b50e8af",
    "storage_key": "property/6767906449166446/019d02ce-9949-7464-8087-7b5e0b50e8af.webp",
    "width": 332,
    "height": 95
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-5da7-768a-9221-bb30f19666be.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
  "property_company_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019d02c4-532b-737e-bc65-d92182ca8ca4",
    "storage_key": "company/5742705921490944/019d02c4-532b-737e-bc65-d92182ca8ca4.webp",
    "width": 640,
    "height": 309
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "Logo for Apartment Management Consultants with a house icon.",
    "public_id": "019f6696-c195-7642-9eb0-0a4d0423bad7",
    "storage_key": "company/5742705921490944/019f6696-c195-7642-9eb0-0a4d0423bad7.webp",
    "width": 320,
    "height": 154
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Apartment Management Consultants logo",
    "public_id": "019f6696-f877-771a-b04d-e0c2089d85b0",
    "storage_key": "company/5742705921490944/019f6696-f877-771a-b04d-e0c2089d85b0.webp",
    "width": 320,
    "height": 154
  },
  "property_primary_color": "#000000",
  "property_secondary_color": "#ffffff",
  "property_font_color": "#000000",
  "property_color_4": null,
  "property_color_3": "#eb0505",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": "#f9f9f9",
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "863 - 1384",
  "property_sqft_min": "863",
  "property_sqft_max": "1384",
  "property_price_range": "$1225 - $1875",
  "property_price_min": "1225",
  "property_price_max": "1875",
  "property_available_units": 36,
  "property_facebook_url": "https://www.facebook.com/PinnacleHeightsApartments",
  "property_instagram_url": "https://www.instagram.com/pinnacleheights_apts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ7U2n9adu1oYRKxAi_09T8d8",
  "property_youtube_url": "https://www.youtube.com/watch?t=264&v=F8hO4wmojfw",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Tucson%2C+AZ",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Pinnacle Heights",
  "property_home_romance_title": "Embrace Comfort and Joy in Your New Apartment Home",
  "property_home_amenities_blurb": "At Pinnacle Heights in Tucson, AZ, experience the perfect blend of relaxation and modern living. Dive into our newly renovated resort-style pool, unwind in the cozy clubhouse with complimentary coffee, or work out in our state-of-the-art fitness center. Each apartment features elegant quartz countertops, spacious layouts, and stunning mountain views.",
  "property_home_floorplans_blurb": "Welcome to Pinnacle Heights, where the vibrant spirit of Tucson, AZ, meets contemporary living. Choose from our thoughtfully designed floor plans tailored to your lifestyle. Each apartment is a sanctuary of comfort and style, waiting for you to make it your own. Browse our available homes and envision your new beginning today!",
  "property_home_gallery_blurb": "At Pinnacle Heights in Tucson, AZ, your dream home awaits. Embrace resort-style living with a newly renovated pool, a relaxing clubhouse, and fitness amenities. Enjoy spectacular mountain views from your private balcony, or host a weekend BBQ in the outdoor picnic area. Picture yourself living here, surrounded by luxury and comfort!",
  "property_home_neighborhood_blurb": "At Pinnacle Heights in Tucson, AZ, your next adventure awaits just beyond your doorstep. Immerse yourself in the local culture with nearby gems like the Tucson Desert Art Museum, Pima Medical Institute, and the enchanting Tucson Botanical Gardens. Find your ideal space among our spacious one, two, or three-bedroom floor plans!",
  "property_home_reviews_blurb": "At Pinnacle Heights in Tucson, AZ, residents rave about our warm community vibe, saying, “It truly feels like home here.” With stunning views and top-notch amenities, your perfect lifestyle awaits. Dive into our reviews and see what makes living at Pinnacle Heights unforgettable—your new home is just a click away!",
  "property_neighborhood_blurb": "At Pinnacle Heights in Tucson, AZ, vibrant local culture meets modern living! Just steps away, immerse yourself in art at the Tucson Desert Art Museum, explore nature at Sabino Canyon Recreation Area, or enjoy community events at the nearby Martha Cooper Library. Uncover the enriching experiences waiting outside your door!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Pinnacle Heights in Tucson, AZ, luxury meets comfort in every detail. Enjoy our newly renovated apartments featuring stunning quartz countertops, spacious patios, and breathtaking mountain views. Unwind in our clubhouse with a coffee bar, or rejuvenate at the resort-style pool. Experience the lifestyle you deserve today!",
  "property_applynow_blurb": "At Pinnacle Heights in Tucson, AZ, experience a lifestyle that blends comfort and luxury. Choose from spacious one to three-bedroom floor plans tailored to your needs. Enjoy our newly renovated apartments, complete with quartz countertops and stunning mountain views. Make every day special with our resort-style amenities and vibrant community spirit.",
  "property_contactus_blurb": "At Pinnacle Heights in Tucson, AZ, our thoughtfully designed floor plans cater to your lifestyle—whether you seek a cozy one-bedroom retreat, a spacious two-bedroom for family, or an expansive three-bedroom home. Have questions? Contact our leasing team today and let us help you find your perfect fit!",
  "property_faqs_blurb": "At Pinnacle Heights in Tucson, AZ, we offer a variety of floor plans designed to fit your lifestyle, from cozy one-bedroom retreats to spacious three-bedroom homes. Got questions? Our FAQs page is your go-to resource for insights about our vibrant community and living experience.",
  "property_floorplans_blurb": "At Pinnacle Heights in Tucson, AZ, we offer a diverse selection of thoughtfully designed floor plans—one, two, and three bedrooms await your unique lifestyle. Each apartment combines comfort with modern elegance. Browse our available homes to uncover the ideal layout that complements your vision of home.",
  "property_gallery_blurb": "At Pinnacle Heights in Tucson, AZ, each apartment tells a story of comfort and style. Picture vibrant living spaces featuring quartz countertops, large walk-in closets, and private patios, alongside resort-style amenities like a relaxing clubhouse and stunning mountain views. Experience elevated living—your new home awaits!",
  "property_interactivemap_blurb": "At Pinnacle Heights in Tucson, AZ, your perfect home awaits! Choose from spacious one, two, or three-bedroom floor plans, and enjoy top-tier amenities like a resort-style swimming pool, state-of-the-art fitness center, and stunning mountain views. Use our interactive community map to find your ideal apartment today!",
  "property_pets_blurb": "At Pinnacle Heights in Tucson, AZ, your furry friends are cherished! With a warm and welcoming pet policy, you can share your home with up to two pets (subject to approval). Create memories in our vibrant community while enjoying the stunning desert scenery together. Embrace life at Pinnacle Heights!",
  "property_referafriend_blurb": "At Pinnacle Heights in Tucson, AZ, living is a breeze with thoughtfully designed one, two, and three-bedroom floor plans that cater to your lifestyle. With stunning views and a vibrant community, great friends make great neighbors—refer a friend today and elevate your home experience together!",
  "property_residentaccess_blurb": "At Pinnacle Heights in vibrant Tucson, AZ, your perfect home awaits among our thoughtfully designed one, two, and three-bedroom floor plans. Enjoy seamless living with our resident portal—effortlessly pay rent, schedule maintenance, and stay connected. Your elevated lifestyle starts here; access your resident portal today!",
  "property_reviews_blurb": "At Pinnacle Heights in Tucson, AZ, residents rave about the vibrant community spirit and exceptional amenities. “Living here feels like a dream; the staff are attentive, and the surroundings are beautiful!” Dive into reviews that highlight why this is more than just an apartment—it's a place to call home!",
  "property_created_at": "1759782580049",
  "property_scheduletour_blurb": "At Pinnacle Heights in sunny Tucson, AZ, our variety of floor plans—one, two, and three bedrooms—are designed to elevate your lifestyle. Ready to envision your new home? Schedule a tour today and hear firsthand from our residents about the vibrant community that awaits you!",
  "property_thankyou_blurb": "Thank you for your interest in Pinnacle Heights, where Tucson’s vibrant lifestyle meets luxurious living. With thoughtfully designed one, two, and three-bedroom floor plans, you’ll find the perfect fit for your lifestyle. Our team will be in touch soon to help you take the next step toward your new home!",
  "property_virtualtours_blurb": "At Pinnacle Heights in Tucson, AZ, enjoy the perfect blend of comfort and style with our thoughtfully designed one, two, and three-bedroom floor plans. Experience the vibrant community from the comfort of your home—take a virtual tour to envision your next residence today!",
  "property_copyright": "2025 All Rights Reserved. Pinnacle Heights",
  "property_seo_title_home": "Pinnacle Heights | Apartments in Tucson, AZ",
  "property_seo_description_home": "Elevate your living at Pinnacle Heights in Tucson, AZ! Enjoy chic amenities, stunning mountain views, and stylish apartments. Your ideal home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Tucson, AZ Apartments for Rent",
  "property_seo_description_floorplans": "Elevate your lifestyle at Pinnacle Heights in Tucson, AZ. Browse diverse one to three-bedroom floor plans and find the space that suits your unique style!",
  "property_seo_title_amenities": "Amenities | Tucson, AZ Apartments for Rent",
  "property_seo_description_amenities": "Experience Tucson living at Pinnacle Heights! Enjoy resort-style amenities, spacious floor plans, and breathtaking mountain views. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Tucson, AZ",
  "property_seo_description_gallery": "Experience Pinnacle Heights in Tucson, AZ—stunning views, modern amenities, and inviting spaces await in your dream home!",
  "property_seo_title_virtualtours": "Virtual Tours | 2 Bedroom Apartments in Tucson, AZ",
  "property_seo_description_virtualtours": "Step into your future home at Pinnacle Heights in Tucson, AZ! Experience our stunning one, two, and three-bedroom apartments with a virtual tour today!",
  "property_seo_title_interactivemap": "Thank You |  Apartments For Rent Near University of Arizona",
  "property_seo_description_interactivemap": "Interested in learning more about Pinnacle Heights Apartments in Tucson, AZ? Contact our team to learn more about any specials and opportunity.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tucson",
  "property_seo_description_neighborhood": "Experience the vibrant Tucson lifestyle at Pinnacle Heights. Uncover local gems and favorites just steps from your door. Your ideal neighborhood awaits!",
  "property_seo_title_contact": "Contact Us | 1 Bedroom Apartments in Tucson, AZ",
  "property_seo_description_contact": "Connect with Pinnacle Heights in Tucson, AZ! Inquire about our stylish one, two, and three-bedroom floor plans. Your new home awaits—reach out today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tucson, AZ",
  "property_seo_description_faqs": "Find answers to your questions at Pinnacle Heights in Tucson, AZ. Learn about our stunning apartments, top-notch amenities, and community perks today!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tucson, AZ",
  "property_seo_description_reviews": "Discover Pinnacle Heights in Tucson, AZ! Enjoy stunning views, resort-style amenities, and a vibrant community. Join us today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tucson, AZ",
  "property_seo_description_applynow": "Elevate your lifestyle at Pinnacle Heights, Tucson! Enjoy luxury amenities, stunning views, and spacious floor plans. Apply online today!",
  "property_seo_title_residentaccess": "Apply Now | Apartments in Tucson, AZ",
  "property_seo_description_residentaccess": "Elevate your lifestyle at Pinnacle Heights, Tucson! Enjoy luxury amenities, stunning views, and spacious floor plans. Apply online today!",
  "property_seo_title_referafriend": "Refer A Friend | Pinnacle Heights",
  "property_seo_description_referafriend": "Refer a friend to Pinnacle Heights in Tucson, AZ! Great friends make great neighbors—share the vibrant community and enjoy exclusive rewards together!",
  "property_seo_title_scheduletour": "Schedule a Tour | Apartments in Tucson, AZ",
  "property_seo_description_scheduletour": "Experience the allure of Pinnacle Heights in Tucson, AZ! Schedule a tour today and envision your vibrant new home surrounded by comfort and community.",
  "property_seo_title_privacy": "Privacy Policy | Pinnacle Heights",
  "property_seo_description_privacy": "At Pinnacle Heights in Tucson, your privacy matters. Learn how we protect your information and ensure a secure living experience. View our privacy policy now!",
  "property_seo_title_accessibility": "Website Accessibility | Pinnacle Heights",
  "property_seo_description_accessibility": "At Pinnacle Heights in Tucson, AZ, we embrace digital inclusion and accessibility. Join our welcoming community where everyone belongs!",
  "property_seo_title_sitemap": "Sitemap | Pinnacle Heights",
  "property_seo_description_sitemap": "Unlock the full potential of Pinnacle Heights in Tucson, AZ! Navigate our sitemap for a seamless journey through vibrant living and community amenities.",
  "property_seo_title_thankyou": "Thank You | Pinnacle Heights",
  "property_seo_description_thankyou": "Thank you for reaching out to Pinnacle Heights! A team member will connect with you soon to unveil your future oasis in Tucson, AZ. Exciting times ahead!",
  "property_seo_title_pets": "Pets | Apartments in Tucson, AZ",
  "property_seo_description_pets": "At Pinnacle Heights in Tucson, AZ, your furry friends are cherished! With a warm and welcoming pet policy, you can share your home with up to two pets.",
  "property_updated_at": "1786643159550",
  "amenities": [
    {
      "id": "custom_1f84e2ad-0231-4f66-870e-75adcbb68e06",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Relaxing Clubhouse with Coffee Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_2a3720c0-3d6d-45ab-854f-2272f4d4bc1b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Resort Style Swimming Pool and Spa",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_a90f1a1e-378b-41c1-940e-c8c286f1a0a5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Picnic Area with Gas Grills",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d2ab8f27-4884-45e1-a080-a4778dc3bb36",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Detached Garages",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_d5e5317c-ca78-4195-ac3d-31238bb5dab2",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Covered Parking",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_07a5a57b-8555-478e-9188-4f3e5f85550c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Online Payment Services",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_09cf0412-5109-4436-828a-741151ab3b05",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "24 Hour Emergency Maintenance",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e7296d58-2feb-4312-8586-b6063aa3e796",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Spectacular Mountain Views",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e8d59944-5b1b-4024-9318-6e04efaab39f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Yoga/Spin Room",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4d35fe41-9ece-4980-bf7c-c2353db31e32",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "State-Of-The-Art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ce2078f3-6056-4659-9b99-f9bc309720b0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Amazon Parcel Lockers",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_984287af-9149-4a8b-a6c4-a70a11d01d4f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Complimentary Coffee Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_e96e0c5e-0468-47dc-8d53-d6884013948b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Newly Renovated Apartment Homes",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_899fb933-76ef-4ad0-ab6e-56eb6e95d6de",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Large Walk-In Closets*",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9846e014-ec4c-4033-8f4e-eeb79dced38f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "9 Foot Ceilings",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_61297300-8bd5-443d-8432-6f86f890bcb7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "E-STAR Stainless Steel Appliances with Ice Makers*",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ff72a78c-dc5c-4eab-924f-82f67dc27856",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Wood Burning Fireplaces*",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f63439a7-0f88-44fd-833a-c2ce44e55322",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Property Wide Fiber Optic Internet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_734515a1-bacb-4cbc-86bc-397422e2fb62",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Breakfast Bar*",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_9f27e008-e80d-4402-8f33-46a9f4692205",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Full Size Washer and Dryers",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_0a646b8e-6ee7-4c3d-8fa3-886a14070058",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Large Private Patios or Balconies*",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_00faf0df-445a-4a0e-bd32-90f6e6bd3f63",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Fiber Optic Internet",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_ac97f55b-1032-4a28-a7a6-fd423b7488ce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Central AC and Heat",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_f65d31a3-6b60-451b-b0d3-8734c145732b",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Beautiful Views*",
      "amount": "false",
      "description": "*Only in select units",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_4bcc5c96-3540-46f3-a4dc-51a4cc5c6139",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Wood-Style Plank Flooring",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    },
    {
      "id": "custom_7ffe81d0-f42c-417d-88ea-341b88ca9f5d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz Countertops*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": ""
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_a0cbdf86-9f9d-4c3a-ac26-334a2c5864d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-abbc-704b-b574-f263392a81d3.webp",
      "image_media": {
        "alt_text": "Exterior view of the apartment complex with a prominent leasing center and mountainous backdrop at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-abbc-704b-b574-f263392a81d3",
        "storage_key": "property/6767906449166446/01a016f7-abbc-704b-b574-f263392a81d3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover your new home at this beautiful apartment community, featuring a welcoming leasing center and stunning desert mountain views.",
      "link": "",
      "alt_text": "Exterior view of the apartment complex with a prominent leasing center and mountainous backdrop at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_146030b0-a46c-4b73-ae0c-a6ab14681f51",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-ed30-774a-89b6-f8e6887bef0c.webp",
      "image_media": {
        "alt_text": "Welcome to Pinnacle Heights leasing center and monument sign.",
        "public_id": "01a016f7-ed30-774a-89b6-f8e6887bef0c",
        "storage_key": "property/6767906449166446/01a016f7-ed30-774a-89b6-f8e6887bef0c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Pinnacle Heights apartment community, featuring a leasing center and exterior monument sign.",
      "link": "",
      "alt_text": "Welcome to Pinnacle Heights leasing center and monument sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_eb05b0a8-ac80-4e8c-b1ef-1ca978c526b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f66a6-f028-7145-993d-f40ac431b72a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with stairs and landscaping at Pinnacle Heights in Tucson, AZ.",
        "public_id": "019f66a6-f028-7145-993d-f40ac431b72a",
        "storage_key": "property/6767906449166446/019f66a6-f028-7145-993d-f40ac431b72a.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "The exterior of the apartment buildings, featuring stucco walls, tile roofs, and well-maintained landscaping with a pathway.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with stairs and landscaping at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8f6b4e25/dms3rep/multi/5742705921490944/6767906449166446/ae54e98f3f5a18ee82b81d9108933841.jpg"
    },
    {
      "id": "custom_722fc6bf-e4c0-45e8-9ad5-0446aaf56a77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-ec9b-716a-a241-a480df3ce330.webp",
      "image_media": {
        "alt_text": "Modern clubhouse lounge with pool view, fireplace, pool table, and kitchen area at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-ec9b-716a-a241-a480df3ce330",
        "storage_key": "property/6767906449166446/01a016f7-ec9b-716a-a241-a480df3ce330.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the spacious and well-appointed clubhouse, featuring a lounge area with a pool table, a cozy fireplace, and a full kitchen, all with stunning views of the adjacent swimming pool.",
      "link": "",
      "alt_text": "Modern clubhouse lounge with pool view, fireplace, pool table, and kitchen area at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9ef144a8-3baa-443e-9c61-4e79be8de0d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-f9e7-77be-acc0-93552569784a.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with a pool table, fireplace, and seating areas at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-f9e7-77be-acc0-93552569784a",
        "storage_key": "property/6767906449166446/01a016f7-f9e7-77be-acc0-93552569784a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy leisure time in our vibrant community lounge, featuring a billiards table, cozy fireplace, and comfortable seating, perfect for socializing or relaxing.",
      "link": "",
      "alt_text": "Spacious community lounge with a pool table, fireplace, and seating areas at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_071ef351-fc0f-45e7-8494-7e023b2158e2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-f98d-7538-b56a-5da15ae24129.webp",
      "image_media": {
        "alt_text": "Billiard room with pool table and mountain view at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-f98d-7538-b56a-5da15ae24129",
        "storage_key": "property/6767906449166446/01a016f7-f98d-7538-b56a-5da15ae24129.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a game of billiards in our stylish game room, featuring a professional pool table and stunning mountain views.",
      "link": "",
      "alt_text": "Billiard room with pool table and mountain view at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_298722f7-3f09-4eea-8c2b-bce98492c069",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f8-0965-7314-b9fb-74b0f67946ae.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight machines, and free weights at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f8-0965-7314-b9fb-74b0f67946ae",
        "storage_key": "property/6767906449166446/01a016f8-0965-7314-b9fb-74b0f67946ae.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight machines, and free weights at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3591d61e-a014-46c7-80ac-25e62a48ee05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-68a8-716a-bb4e-cfd83fc3db67.webp",
      "image_media": {
        "alt_text": "Interior of a modern fitness center with cardio equipment and exercise balls.",
        "public_id": "01a016f7-68a8-716a-bb4e-cfd83fc3db67",
        "storage_key": "property/6767906449166446/01a016f7-68a8-716a-bb4e-cfd83fc3db67.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center, equipped with cardio machines, free weights, and exercise balls.",
      "link": "",
      "alt_text": "Interior of a modern fitness center with cardio equipment and exercise balls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f3369653-c693-446c-86f3-cf2b19bbcdc8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f66a6-fd21-76ac-80d0-a10709ed372d.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with palm trees and apartment buildings in the background at Pinnacle Heights in Tucson, AZ.",
        "public_id": "019f66a6-fd21-76ac-80d0-a10709ed372d",
        "storage_key": "property/6767906449166446/019f66a6-fd21-76ac-80d0-a10709ed372d.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling resort-style swimming pool, surrounded by lush palm trees and beautiful apartment buildings. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Resort-style swimming pool with palm trees and apartment buildings in the background at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8f6b4e25/dms3rep/multi/5742705921490944/6767906449166446/21cac2a8d23948680dc5905609bd32a8.jpg"
    },
    {
      "id": "custom_da6caf54-0fa9-4453-aa49-c2537bb5764b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f66a6-fdfb-70cd-9a3b-46f99c3c50c0.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool and lounge area surrounded by palm trees and apartment buildings with mountains in the background.",
        "public_id": "019f66a6-fdfb-70cd-9a3b-46f99c3c50c0",
        "storage_key": "property/6767906449166446/019f66a6-fdfb-70cd-9a3b-46f99c3c50c0.webp",
        "width": 1920,
        "height": 1440
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxation and fun. Lounge chairs and umbrellas are available for your comfort.",
      "link": "",
      "alt_text": "Resort-style swimming pool and lounge area surrounded by palm trees and apartment buildings with mountains in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8f6b4e25/dms3rep/multi/DJI_0904.jpg"
    },
    {
      "id": "custom_68389a14-600f-47ec-99a2-33dbb49463be",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f66a6-fe89-72ce-960c-555588896f82.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at Pinnacle Heights in Tucson, AZ.",
        "public_id": "019f66a6-fe89-72ce-960c-555588896f82",
        "storage_key": "property/6767906449166446/019f66a6-fe89-72ce-960c-555588896f82.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Pool at Pinnacle Heights in Tucson, AZ.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and palm trees at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/8f6b4e25/dms3rep/multi/5742705921490944/6767906449166446/9168507101347fa66290ab6b847cdc9d.jpg"
    },
    {
      "id": "custom_650a191d-f843-4ee9-905e-4b2a4a4134d8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-b4ba-73ee-8bf7-c3c7f96e946d.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with two built-in stainless steel grills and a trash receptacle.",
        "public_id": "01a016f7-b4ba-73ee-8bf7-c3c7f96e946d",
        "storage_key": "property/6767906449166446/01a016f7-b4ba-73ee-8bf7-c3c7f96e946d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking with our community's spacious grilling area, perfect for gatherings and al fresco dining.",
      "link": "",
      "alt_text": "Outdoor grilling area with two built-in stainless steel grills and a trash receptacle.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a19308f3-a79c-4b41-b2cc-e5ccc719b3de",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-c816-722c-9c39-1672a73b12f2.webp",
      "image_media": {
        "alt_text": "Amazon package lockers for resident convenience at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-c816-722c-9c39-1672a73b12f2",
        "storage_key": "property/6767906449166446/01a016f7-c816-722c-9c39-1672a73b12f2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure Amazon package lockers provide a convenient solution for residents to receive their deliveries safely and efficiently.",
      "link": "",
      "alt_text": "Amazon package lockers for resident convenience at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5feb3d9c-72d3-46d5-b64d-c27b50189a72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-e959-720e-8cd3-08c0c8e6896d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinetry, stainless steel appliances, and a large sink at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-e959-720e-8cd3-08c0c8e6896d",
        "storage_key": "property/6767906449166446/01a016f7-e959-720e-8cd3-08c0c8e6896d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "View our spacious and modern kitchen, featuring dark wood cabinetry, sleek stainless steel appliances, and ample counter space. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinetry, stainless steel appliances, and a large sink at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c8ea53cd-80c1-49a9-bc32-28d6fd14fd8f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-a82d-77cc-b168-da082ffe822e.webp",
      "image_media": {
        "alt_text": "Interior view of an apartment entryway with a white door, a small dining table with chairs, and a large potted plant at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-a82d-77cc-b168-da082ffe822e",
        "storage_key": "property/6767906449166446/01a016f7-a82d-77cc-b168-da082ffe822e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Welcome home! This apartment features a bright entryway with a dining area, perfect for intimate meals or as a workspace.",
      "link": "",
      "alt_text": "Interior view of an apartment entryway with a white door, a small dining table with chairs, and a large potted plant at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4b104218-14bf-4153-93ab-90bdfe31c8ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-d95f-776e-b4f0-41e662fee1c3.webp",
      "image_media": {
        "alt_text": "Living room with a TV, fireplace, and seating area.",
        "public_id": "01a016f7-d95f-776e-b4f0-41e662fee1c3",
        "storage_key": "property/6767906449166446/01a016f7-d95f-776e-b4f0-41e662fee1c3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and inviting living room featuring a modern TV stand, decorative fireplace, comfortable seating, and elegant decor, perfect for relaxation and entertainment.",
      "link": "",
      "alt_text": "Living room with a TV, fireplace, and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ef4232f5-36f3-487f-8136-eacd8688ef94",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016fe-f48d-7103-aa50-ef858ea878a1.webp",
      "image_media": {
        "alt_text": "Modern living room with a white couch, accent chairs, and abstract art at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016fe-f48d-7103-aa50-ef858ea878a1",
        "storage_key": "property/6767906449166446/01a016fe-f48d-7103-aa50-ef858ea878a1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living area, featuring plush seating and contemporary decor.",
      "link": "",
      "alt_text": "Modern living room with a white couch, accent chairs, and abstract art at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e98e7851-1105-47f8-be63-169c190ea379",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-bc21-734e-a82e-c047f24214fb.webp",
      "image_media": {
        "alt_text": "Modern living room with white sofa, accent chairs, coffee table, and sliding glass doors leading to a patio.",
        "public_id": "01a016f7-bc21-734e-a82e-c047f24214fb",
        "storage_key": "property/6767906449166446/01a016f7-bc21-734e-a82e-c047f24214fb.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed living room, featuring a plush white sofa, stylish accent chairs, and a modern coffee table. Enjoy the natural light and access to your private patio through the sliding glass doors.",
      "link": "",
      "alt_text": "Modern living room with white sofa, accent chairs, coffee table, and sliding glass doors leading to a patio.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_4ce72228-f1fd-4b4f-a64d-13552b1ed7b6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-c1f0-7461-a81e-5db88bf0c4be.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, nightstand, and ceiling fan at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-c1f0-7461-a81e-5db88bf0c4be",
        "storage_key": "property/6767906449166446/01a016f7-c1f0-7461-a81e-5db88bf0c4be.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in the comfort of this beautifully appointed bedroom, featuring a plush queen-size bed, elegant nightstand, and a soothing ceiling fan for ultimate comfort.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, nightstand, and ceiling fan at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_a170f7b9-b50e-4c7b-9455-31df486d096e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-af7b-7560-8b5d-91fad196b083.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, mirror, and a bathtub with a shower at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-af7b-7560-8b5d-91fad196b083",
        "storage_key": "property/6767906449166446/01a016f7-af7b-7560-8b5d-91fad196b083.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bathroom, featuring a sleek vanity, modern fixtures, and a relaxing bathtub and shower combination.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, mirror, and a bathtub with a shower at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_28ee3732-2e63-4c83-88dd-4031deae4bbd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016f7-ac14-7497-8c6b-511418e5d41e.webp",
      "image_media": {
        "alt_text": "King-sized bed with plush pillows and a light blue comforter in a bedroom with a dresser and a window at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016f7-ac14-7497-8c6b-511418e5d41e",
        "storage_key": "property/6767906449166446/01a016f7-ac14-7497-8c6b-511418e5d41e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this serene bedroom, featuring a comfortable king-sized bed and elegant decor. The perfect retreat after a long day.",
      "link": "",
      "alt_text": "King-sized bed with plush pillows and a light blue comforter in a bedroom with a dresser and a window at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5cda3a41-cd4e-4ce3-9eff-6307cae45f42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016fe-276e-739c-964f-2fcc93c11619.webp",
      "image_media": {
        "alt_text": "Balcony with two chairs and a table with a plant, overlooking apartment buildings at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016fe-276e-739c-964f-2fcc93c11619",
        "storage_key": "property/6767906449166446/01a016fe-276e-739c-964f-2fcc93c11619.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening relaxation on your private balcony, offering scenic views of the surrounding community.",
      "link": "",
      "alt_text": "Balcony with two chairs and a table with a plant, overlooking apartment buildings at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3796e42f-ab4b-46aa-8951-685999ec3f5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/01a016fd-fce1-7704-af52-10c765b7d0a9.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry closet, with a basket of towels on top of the dryer. A bathroom vanity is visible through an open doorway at Pinnacle Heights in Tucson, AZ.",
        "public_id": "01a016fd-fce1-7704-af52-10c765b7d0a9",
        "storage_key": "property/6767906449166446/01a016fd-fce1-7704-af52-10c765b7d0a9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs, adjacent to a spacious bathroom with a double vanity.",
      "link": "",
      "alt_text": "Washer and dryer in a laundry closet, with a basket of towels on top of the dryer. A bathroom vanity is visible through an open doorway at Pinnacle Heights in Tucson, AZ.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_878aecc5-109a-4186-8eeb-a6feac6b24b4",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Mt Lemmon Ski Valley",
      "poi_type": "Entertainment",
      "poi_address": "10300 E Ski Run Rd, Mt Lemmon, AZ 85619, USA",
      "poi_short_description": "Recreational area offering winter skiing/snowboarding & summer hiking, plus a restaurant & a cafe.",
      "poi_long_description": "People say this ski resort offers beautiful views, a variety of hiking levels, and a scenic ski lift ride. They highlight the peaceful and enjoyable atmosphere, and the friendly staff. They also like that it's a great place to cool off from the summer heat.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-3bde-70b7-83fa-e1a15245fec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-3bde-70b7-83fa-e1a15245fec2",
        "storage_key": "property/6767906449166446/019d02ce-3bde-70b7-83fa-e1a15245fec2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.skithelemmon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11369746449679501314&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mt-lemmon-ski-valley",
      "poi_latitude": "32.4475",
      "poi_longitude": "-110.7816667",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-576-1321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdW2hATgU1oYRAshnDyh0yZ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "ski_resort"
    },
    {
      "id": "custom_ad16ebe1-88fd-4b46-a534-58352f05a15f",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Canyon Ranch Tucson",
      "poi_type": "Entertainment",
      "poi_address": "8600 E Rockcliff Rd, Tucson, AZ 85750, USA",
      "poi_short_description": "Sprawling wellness resort with all meals included, plus a spa, 4 pools & multiple free activities.",
      "poi_long_description": "Sprawling wellness resort with all meals included, plus a spa, 4 pools & multiple free activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-3db9-7025-b6bb-b4b89da87c29.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-3db9-7025-b6bb-b4b89da87c29",
        "storage_key": "property/6767906449166446/019d02ce-3db9-7025-b6bb-b4b89da87c29.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.canyonranch.com/tucson?utm_source=googlemybusiness&utm_medium=organic&utm_campaign=tucsongmb&utm_term=googlemybusiness",
      "poi_directions_map_url": "https://maps.google.com/?cid=4056282562781508222&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "canyon-ranch-tucson",
      "poi_latitude": "32.2872136",
      "poi_longitude": "-110.8098864",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-749-9655",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP12W7axu1oYRfvIz73_PSjg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_0273b82c-9a0b-418f-b59d-1fd2061cf365",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Ventana Canyon Club and Lodge",
      "poi_type": "Entertainment",
      "poi_address": "6200 N Club House Ln, Tucson, AZ 85750, USA",
      "poi_short_description": "Posh suites in a high-end retreat featuring golf & fine dining, plus a spa & a fitness center.",
      "poi_long_description": "People say this resort hotel offers excellent tennis facilities, a golf course, and a restaurant with delicious food. They highlight the reasonable prices, beautiful views, and comfortable rooms. They also like the helpful and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-414d-721f-a4ee-2fe911e20c4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-414d-721f-a4ee-2fe911e20c4a",
        "storage_key": "property/6767906449166446/019d02ce-414d-721f-a4ee-2fe911e20c4a.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.ventanacanyonclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17866051374212969893&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ventana-canyon-club-and-lodge",
      "poi_latitude": "32.32191",
      "poi_longitude": "-110.84534",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-577-1400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-6998-750e-9118-a17101ff9b83.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-6998-750e-9118-a17101ff9b83",
        "storage_key": "property/6767906449166446/019d02ce-6998-750e-9118-a17101ff9b83.webp",
        "width": 192,
        "height": 122
      },
      "poi_google_place_id": "ChIJVYFXpVps1oYRpfXXAhH38Pc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "resort_hotel"
    },
    {
      "id": "custom_0aa15ea8-34a8-4a8a-ac3e-ba11c567e453",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Golf N' Stuff",
      "poi_type": "Entertainment",
      "poi_address": "6503 E Tanque Verde Rd, Tucson, AZ 85715, USA",
      "poi_short_description": "Family-friendly destination offering go-kart speeds and arcade games, along with bumper boats and laser tag.",
      "poi_long_description": "People say this miniature golf course offers a variety of activities, including mini golf, go-karts, bumper boats, batting cages, and an arcade. They also highlight the fun family atmosphere and friendly staff.\n\nOther reviews mention some games can be glitchy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-3b6f-71ef-bb6a-9926f3d04aee.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-3b6f-71ef-bb6a-9926f3d04aee",
        "storage_key": "property/6767906449166446/019d02ce-3b6f-71ef-bb6a-9926f3d04aee.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://golfnstuff.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2196407453664903376&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "golf-n-stuff",
      "poi_latitude": "32.2464277",
      "poi_longitude": "-110.8544624",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-296-2366",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt1Tqm_9u1oYR0IC3KfE0ex4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "miniature_golf_course"
    },
    {
      "id": "custom_15a3ce5d-868b-46de-9eec-b7cbed0394bb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Trail Dust Town",
      "poi_type": "Entertainment",
      "poi_address": "6541 E Tanque Verde Rd, Tucson, AZ 85715, USA",
      "poi_short_description": "Old West-inspired complex with kid-friendly attractions including a miniature train & stunt shows.",
      "poi_long_description": "People say this tourist attraction offers a fun train ride, a Wild West stunt show, and delicious food at the restaurant. They highlight the affordable ticket prices, the family-friendly atmosphere, and the variety of activities, including rides and shops. They also like the friendly and welcoming staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-41db-7248-885e-513e5618b50b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-41db-7248-885e-513e5618b50b",
        "storage_key": "property/6767906449166446/019d02ce-41db-7248-885e-513e5618b50b.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.traildusttown.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13905709678040064272&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trail-dust-town",
      "poi_latitude": "32.2474341",
      "poi_longitude": "-110.8529292",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-296-4551",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdecUF_9u1oYRECFKzUYB-8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tourist_attraction"
    },
    {
      "id": "custom_8108f80c-c1a1-4217-b043-dc44cfb24bce",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "1260 E Tucson Marketplace Blvd, Tucson, AZ 85713, USA",
      "poi_short_description": "Department store providing a variety of items, including electronics, clothing, and groceries, plus a pharmacy.",
      "poi_long_description": "Shoppers say this department store offers a wide selection of products, including groceries, and convenient services like oil changes and grocery pickup. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nSome reviews mention the store can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-4464-730f-a62e-b78fd38fb954.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-4464-730f-a62e-b78fd38fb954",
        "storage_key": "property/6767906449166446/019d02ce-4464-730f-a62e-b78fd38fb954.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walmart.com/store/5626-tucson-az/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=12271179093796072069&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "32.1854075",
      "poi_longitude": "-110.9536509",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-917-0108",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b22c-75c9-92a8-4aa9967b344a",
        "storage_key": "property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbxIo5X9w1oYRhSrqzF78S6o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a0fe9957-5753-45e2-9bc7-eb5aea737a92",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Park Place Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "5870 E Broadway Blvd, Tucson, AZ 85711, USA",
      "poi_short_description": "Large indoor mall featuring stores for clothing, jewelry and perfume, plus an arcade, a food court and a movie theater.",
      "poi_long_description": "People say this shopping center offers a variety of shops, a movie theater, and a food court with many options. They also highlight the clean and tidy environment, the convenient location, and the enclosed playground for children.\n\nOther reviews mention the mall can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-4645-7668-8127-30b2a7d9ac07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-4645-7668-8127-30b2a7d9ac07",
        "storage_key": "property/6767906449166446/019d02ce-4645-7668-8127-30b2a7d9ac07.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.parkplacemall.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6372946389116496142&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "park-place-mall",
      "poi_latitude": "32.2197213",
      "poi_longitude": "-110.8655208",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-747-0421",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b22c-75c9-92a8-4aa9967b344a",
        "storage_key": "property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJxcC_o6Jv1oYRDqnlv_lAcVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_db93bcdb-19eb-4742-8b70-c7744d2ed146",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "La Encantada",
      "poi_type": "Shopping & Retail",
      "poi_address": "2905 E Skyline Dr, Tucson, AZ 85718, USA",
      "poi_short_description": "Outdoor shopping mall featuring 2 levels of luxury & specialty retail stores, plus restaurants.",
      "poi_long_description": "People say this shopping center is clean, safe, and relaxing with great views of the city and high-end stores like AJ's. They also highlight the beautiful outdoor setting and quiet atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-4b3b-711e-87d3-c68e7ba4e2c9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-4b3b-711e-87d3-c68e7ba4e2c9",
        "storage_key": "property/6767906449166446/019d02ce-4b3b-711e-87d3-c68e7ba4e2c9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.laencantadashoppingcenter.com/?utm_source=google&utm_medium=onlinesearch&utm_content=gmp_website_button&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=7410570946365351839&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "la-encantada",
      "poi_latitude": "32.3248317",
      "poi_longitude": "-110.9296576",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-299-3566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b22c-75c9-92a8-4aa9967b344a",
        "storage_key": "property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJDyRxq_Ny1oYRn-fvSAOj12Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b4270c00-7f58-43c2-9a9e-8ed330acff53",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "1101 N Wilmot Rd Ste 147, Tucson, AZ 85712, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "People say this grocery store offers a wide selection of fresh foods, unique products, and a great wine selection. They highlight the reasonable prices and the friendly, helpful, and knowledgeable staff. They also like the well-stocked shelves and the fun, unique shopping experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-4936-76f2-88b7-e6f341fe5216.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-4936-76f2-88b7-e6f341fe5216",
        "storage_key": "property/6767906449166446/019d02ce-4936-76f2-88b7-e6f341fe5216.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.traderjoes.com/az/tucson/95/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=16072126314407203899&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "32.2372758",
      "poi_longitude": "-110.8584546",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-733-1313",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b22c-75c9-92a8-4f027e1bb148.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b22c-75c9-92a8-4f027e1bb148",
        "storage_key": "property/6767906449166446/019d02cc-b22c-75c9-92a8-4f027e1bb148.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYcoV1qtv1oYROxRzq7qpC98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_7b6b797d-9966-4b21-8bc8-76a5ead75238",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Costco Wholesale",
      "poi_type": "Shopping & Retail",
      "poi_address": "1650 E Tucson Marketplace Blvd, Tucson, AZ 85713, USA",
      "poi_short_description": "Members-only warehouse selling a huge variety of items including bulk groceries, electronics & more.",
      "poi_long_description": "People say this warehouse store offers a wide variety of products, including groceries, household essentials, and seasonal items. They highlight the great deals, bulk pricing, and quality produce, meat, and wines. They also like the helpful and knowledgeable staff, and the clean, well-organized layout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-4a9b-7151-ac9c-1a1236f13c21.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-4a9b-7151-ac9c-1a1236f13c21",
        "storage_key": "property/6767906449166446/019d02ce-4a9b-7151-ac9c-1a1236f13c21.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.costco.com/warehouse-locations/tucson-AZ-1079.html?utm_term=KW&utm_campaign=Homepage&utm_medium=GMB&utm_source=Google&utm_content=Link",
      "poi_directions_map_url": "https://maps.google.com/?cid=4240473098210637388&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "costco-wholesale",
      "poi_latitude": "32.1805536",
      "poi_longitude": "-110.9471663",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-791-7340",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b22c-75c9-92a8-4aa9967b344a",
        "storage_key": "property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgaAOG4F61oYRTPZx2tAv2To",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "warehouse_store"
    },
    {
      "id": "custom_c5461ed7-8890-426a-99e9-2d60833eca94",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "1225 W Irvington Rd, Tucson, AZ 85714, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-4df2-76ba-8200-4d97ecf3e358.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-4df2-76ba-8200-4d97ecf3e358",
        "storage_key": "property/6767906449166446/019d02ce-4df2-76ba-8200-4d97ecf3e358.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/tucson-sw/1316",
      "poi_directions_map_url": "https://maps.google.com/?cid=17292261943803591465&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "32.1608318",
      "poi_longitude": "-110.9900677",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-295-1277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b22c-75c9-92a8-4aa9967b344a",
        "storage_key": "property/6767906449166446/019d02cc-b22c-75c9-92a8-4aa9967b344a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJad-k1Rt61oYRKTtrm550-u8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_34e35954-c013-4b78-842e-7acf7dd59dbf",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "The Cork Tucson",
      "poi_type": "Restaurants",
      "poi_address": "6320 E Tanque Verde Rd, Tucson, AZ 85715, USA",
      "poi_short_description": "Southwestern classic for exotic game & steak in a warm, romantic setting with fireplaces & patio.",
      "poi_long_description": "People say this restaurant serves delicious steaks, seafood, and wild game, including kangaroo and bison. They highlight the hearty sides, extensive wine and cocktail menu, and the cozy, historic atmosphere. They also like the attentive and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-5077-704c-9067-6e0a3f9780fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-5077-704c-9067-6e0a3f9780fd",
        "storage_key": "property/6767906449166446/019d02ce-5077-704c-9067-6e0a3f9780fd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://corktucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18132239080450588397&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-cork-tucson",
      "poi_latitude": "32.2425729",
      "poi_longitude": "-110.8566426",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-296-1631",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b231-749a-89d5-5871be81d357.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b231-749a-89d5-5871be81d357",
        "storage_key": "property/6767906449166446/019d02cc-b231-749a-89d5-5871be81d357.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtfJYtKpv1oYR7X62_F-novs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "southwestern_us_restaurant"
    },
    {
      "id": "custom_6341333d-f520-473d-8919-98fbe14fe6f5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "El Charro Cafe Ventana",
      "poi_type": "Restaurants",
      "poi_address": "6910 E Sunrise Dr, Tucson, AZ 85750, USA",
      "poi_short_description": "Long-standing Mexican cafe with a colorful vibe offering a menu of Sonoran-style fare.",
      "poi_long_description": "People say this Mexican restaurant serves delicious carne seca, carnitas, and tamales. They also highlight the friendly staff, refreshing margaritas, and the beautiful patio with mountain views.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-534f-71c3-99e6-8282f347af47.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-534f-71c3-99e6-8282f347af47",
        "storage_key": "property/6767906449166446/019d02ce-534f-71c3-99e6-8282f347af47.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.elcharrocafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2057077948016653625&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "el-charro-cafe-ventana",
      "poi_latitude": "32.3078163",
      "poi_longitude": "-110.8449366",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-514-1922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b231-749a-89d5-5871be81d357.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b231-749a-89d5-5871be81d357",
        "storage_key": "property/6767906449166446/019d02cc-b231-749a-89d5-5871be81d357.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJpcuW6jds1oYROXXSrn41jBw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_fcb24eb9-6bc0-4f7f-b0b5-c22e37d81078",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Bistro 44",
      "poi_type": "Restaurants",
      "poi_address": "6761 E Tanque Verde Rd, Tucson, AZ 85715, USA",
      "poi_short_description": "Classic American dishes such as steaks and scallops served in a relaxed atmosphere with a bar and a patio.",
      "poi_long_description": "Diners say this American restaurant serves delicious burgers, especially on Sundays when they're half off, and braised short ribs. They also highlight the friendly and attentive service, and the comfortable atmosphere.\n\nSome reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-559c-7784-ba58-77ca66168db9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-559c-7784-ba58-77ca66168db9",
        "storage_key": "property/6767906449166446/019d02ce-559c-7784-ba58-77ca66168db9.webp",
        "width": 1280,
        "height": 797
      },
      "poi_business_url": "http://www.bistro44tucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16289993479825658905&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bistro-44",
      "poi_latitude": "32.249946",
      "poi_longitude": "-110.8481266",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-298-2233",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b231-749a-89d5-5871be81d357.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b231-749a-89d5-5871be81d357",
        "storage_key": "property/6767906449166446/019d02cc-b231-749a-89d5-5871be81d357.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJMY_19Ptu1oYRGRRwBsOuEeI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_04a62df5-3fcc-4153-9ee5-5da52e9890ab",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Arizona Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "4955 N Sabino Canyon Rd, Tucson, AZ 85750, USA",
      "poi_short_description": "Laid-back pizzeria for by-the-slice or whole pies features a full bar & sports on TV.",
      "poi_long_description": "People say this pizza restaurant serves delicious pizza with a crispy crust and fresh ingredients, as well as tasty wings. They also highlight the generous portions, good value, and family-friendly atmosphere.\n\nOther reviews mention the service can be sporadic.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-564c-755e-bde1-8e47d15fb759.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-564c-755e-bde1-8e47d15fb759",
        "storage_key": "property/6767906449166446/019d02ce-564c-755e-bde1-8e47d15fb759.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://azpizzacompany.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3762095356437983603&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "arizona-pizza-company",
      "poi_latitude": "32.2972447",
      "poi_longitude": "-110.8245798",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-299-7311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b231-749a-89d5-5871be81d357.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b231-749a-89d5-5871be81d357",
        "storage_key": "property/6767906449166446/019d02cc-b231-749a-89d5-5871be81d357.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJodzeCRxs1oYRc_GhU8ulNTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_4cb29053-ce87-49a6-a972-d5e99f38009a",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "The Ranch Bar and Grill - Tucson",
      "poi_type": "Restaurants",
      "poi_address": "9155 E Tanque Verde Rd #177, Tucson, AZ 85749, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this bar and grill serves delicious burgers, steaks, and wings. They also highlight the friendly and attentive staff, the fun and energetic atmosphere, and the live music.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-5912-740b-8029-2a5d95f04380.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-5912-740b-8029-2a5d95f04380",
        "storage_key": "property/6767906449166446/019d02ce-5912-740b-8029-2a5d95f04380.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.theranchbarandgrilltucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1902306554393912003&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-ranch-bar-and-grill---tucson",
      "poi_latitude": "32.2580604",
      "poi_longitude": "-110.7965448",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-468-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-6b14-74da-8aef-3a295f1ffd79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-6b14-74da-8aef-3a295f1ffd79",
        "storage_key": "property/6767906449166446/019d02ce-6b14-74da-8aef-3a295f1ffd79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZtSQQBp1oYRw-KLfLtZZho",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_153f23f5-de06-47e2-9226-2717abd4741d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Three Canyon Beer and Wine Garden",
      "poi_type": "Restaurants",
      "poi_address": "4999 N Sabino Canyon Rd, Tucson, AZ 85750, USA",
      "poi_short_description": "Casual beer garden featuring a dog-friendly outdoor space for live music, food trucks, burgers, and beers on tap.",
      "poi_long_description": "People say this beer garden offers a wide selection of beers on tap and in coolers, as well as delicious quesadillas and street nachos. They also highlight the friendly staff, live music, and dog-friendly outdoor area.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-5ac3-7351-986d-e2087b7e6b9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02ce-5ac3-7351-986d-e2087b7e6b9f",
        "storage_key": "property/6767906449166446/019d02ce-5ac3-7351-986d-e2087b7e6b9f.webp",
        "width": 1280,
        "height": 677
      },
      "poi_business_url": "http://www.threecanyon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17654826171289494135&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "three-canyon-beer-and-wine-garden",
      "poi_latitude": "32.2977483",
      "poi_longitude": "-110.8246367",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-900-7866",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02ce-6b14-74da-8aef-3a295f1ffd79.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02ce-6b14-74da-8aef-3a295f1ffd79",
        "storage_key": "property/6767906449166446/019d02ce-6b14-74da-8aef-3a295f1ffd79.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4fPA7xts1oYRd-L6Dt2KAvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "beer_garden"
    },
    {
      "id": "custom_78b6c2fd-2b18-4481-ae46-822cd04e4cee",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Murphy-Wilmot Library",
      "poi_type": "Education",
      "poi_address": "530 N Wilmot Rd, Tucson, AZ 85710, USA",
      "poi_short_description": "Clean and airy library for kids and adults, plus computers and study rooms, plus helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-85de-7593-8145-81baaa5185e9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-85de-7593-8145-81baaa5185e9",
        "storage_key": "property/6767906449166446/019d02cc-85de-7593-8145-81baaa5185e9.webp",
        "width": 1000,
        "height": 500
      },
      "poi_business_url": "http://www.library.pima.gov/locations/wil/",
      "poi_directions_map_url": "https://maps.google.com/?cid=242247972203976485&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "murphy-wilmot-library",
      "poi_latitude": "32.2277323",
      "poi_longitude": "-110.8572003",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 520-594-5420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b22c-75c9-92a8-54ffb054aa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b22c-75c9-92a8-54ffb054aa80",
        "storage_key": "property/6767906449166446/019d02cc-b22c-75c9-92a8-54ffb054aa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJv9InYp5v1oYRJdfGSj-jXAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_a097135a-c06c-47ed-a88e-e9b2704d8837",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Pima Medical Institute - Tucson",
      "poi_type": "Education",
      "poi_address": "2121 N Craycroft Rd Building 1, Tucson, AZ 85712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-871c-71bf-8ca6-7e3deb70b231.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-871c-71bf-8ca6-7e3deb70b231",
        "storage_key": "property/6767906449166446/019d02cc-871c-71bf-8ca6-7e3deb70b231.webp",
        "width": 1080,
        "height": 720
      },
      "poi_business_url": "https://pmi.edu/locations/arizona/tucson/?utm_campaign=gmbwebsite&utm_content=tucson&utm_medium=organic&utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=14349571889353006884&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pima-medical-institute---tucson",
      "poi_latitude": "32.2482723",
      "poi_longitude": "-110.8778811",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 800-477-7462",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b22c-75c9-92a8-54ffb054aa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b22c-75c9-92a8-54ffb054aa80",
        "storage_key": "property/6767906449166446/019d02cc-b22c-75c9-92a8-54ffb054aa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-xY5ZMFx1oYRJB_RJ5vrI8c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_6e25fff3-b967-43ea-81be-2f1a40b75704",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Martha Cooper Library",
      "poi_type": "Education",
      "poi_address": "1377 N Catalina Ave, Tucson, AZ 85712, USA",
      "poi_short_description": "Community library featuring plenty of space, a kids' area and friendly staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-89d3-70a7-888c-a955cb8b4666.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-89d3-70a7-888c-a955cb8b4666",
        "storage_key": "property/6767906449166446/019d02cc-89d3-70a7-888c-a955cb8b4666.webp",
        "width": 1280,
        "height": 722
      },
      "poi_business_url": "http://www.library.pima.gov/locations/mid/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9056003158038080674&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "martha-cooper-library",
      "poi_latitude": "32.2392459",
      "poi_longitude": "-110.8994414",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 520-594-5315",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b22c-75c9-92a8-54ffb054aa80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b22c-75c9-92a8-54ffb054aa80",
        "storage_key": "property/6767906449166446/019d02cc-b22c-75c9-92a8-54ffb054aa80.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJy5lhtytu1oYRouysN-RirX0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_bee3c394-6841-42c4-9a01-22e2c90e25b0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "3920 E Grant Rd, Tucson, AZ 85712, USA",
      "poi_short_description": "Gym offering group fitness classes, personal training, and an indoor pool, as well as child care.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including cardio machines, weights, a pool, and a sauna. They also highlight the friendly and helpful staff, and the positive and welcoming atmosphere.\n\nOther reviews mention the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-9132-716f-b7e2-56985a3ff085.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-9132-716f-b7e2-56985a3ff085",
        "storage_key": "property/6767906449166446/019d02cc-9132-716f-b7e2-56985a3ff085.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://vasafitness.com/locations/az/tucson/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=5662576655666926584&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "32.2492971",
      "poi_longitude": "-110.9085126",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 520-232-2044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJE3LhWQxx1oYR-FNyeneDlU4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_80995f24-a211-4c68-9a5b-f88963a43ec8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Chuze Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "5548 E Grant Rd, Tucson, AZ 85712, USA",
      "poi_short_description": "Chain of fitness centers offering membership packages for activities, equipment and classes.",
      "poi_long_description": "People say this fitness center offers a wide variety of equipment, including free weights, and amenities such as a pool, sauna, and steam room. They highlight the clean facilities, good choice of music, and positive energy. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-9269-717f-8a82-7dc90ae8f8ac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-9269-717f-8a82-7dc90ae8f8ac",
        "storage_key": "property/6767906449166446/019d02cc-9269-717f-8a82-7dc90ae8f8ac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://chuzefitness.com/gym-locations/az/grant-craycroft/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7059082857038837345&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chuze-fitness",
      "poi_latitude": "32.2492982",
      "poi_longitude": "-110.8726149",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 520-600-2712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaVEv2iRu1oYRYXbZNXXm9mE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_3cb3321a-1c6f-4b17-8b3b-846f508c5686",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "240 S Wilmot Rd, Tucson, AZ 85711, USA",
      "poi_short_description": "Friendly chain offering cardio training, free-weight workouts, classes, a pool and a sauna.",
      "poi_long_description": "People say this gym offers a wide variety of equipment, including machines, free weights, and a pool, as well as group fitness classes and personal training. They also highlight the clean facilities, welcoming atmosphere, and friendly, helpful staff.\n\nOther reviews mention the sauna and hot tub can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-94af-71fd-97a9-e81433719af2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-94af-71fd-97a9-e81433719af2",
        "storage_key": "property/6767906449166446/019d02cc-94af-71fd-97a9-e81433719af2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=253&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1588046668497893153&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "32.2189855",
      "poi_longitude": "-110.8602396",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 520-748-1295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrcRQqJ9v1oYRITeP-gfgCRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_e8891ae9-9f4a-421a-aeb7-a153950476e1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Ott Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "401 S Prudence Rd, Tucson, AZ 85710, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-94cc-75fc-bebd-abcbb668e4b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-94cc-75fc-bebd-abcbb668e4b5",
        "storage_key": "property/6767906449166446/019d02cc-94cc-75fc-bebd-abcbb668e4b5.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://tucsonymca.org/location/ott-family-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15302191957267019858&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ott-family-ymca",
      "poi_latitude": "32.2141139",
      "poi_longitude": "-110.83132",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 520-885-2317",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6G_SAFv1oYRUni9uYJOXNQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_756f6e59-cfcb-492a-8872-bd8173a3ec92",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Southern Arizona Veterinary Specialty and Emergency Center",
      "poi_type": "Health and Wellness",
      "poi_address": "7474 E Broadway Blvd, Tucson, AZ 85710, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-9b26-774f-910d-5d84e69ddb6a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-9b26-774f-910d-5d84e69ddb6a",
        "storage_key": "property/6767906449166446/019d02cc-9b26-774f-910d-5d84e69ddb6a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.southernazvets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9768960025471857870&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "southern-arizona-veterinary-specialty-and-emergency-center",
      "poi_latitude": "32.2205163",
      "poi_longitude": "-110.832867",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 520-888-3177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJa3NPGGpv1oYRzrQ9j2JRkoc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_f5953a62-2d4f-423d-878f-37c1ed492ca9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "ABC Vaccination Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "5350 E Broadway Blvd #118, Tucson, AZ 85711, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-9a58-731e-b073-082ce254f9e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-9a58-731e-b073-082ce254f9e3",
        "storage_key": "property/6767906449166446/019d02cc-9a58-731e-b073-082ce254f9e3.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "http://www.animalbirthcontroltucson.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2287602236930788687&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "abc-vaccination-clinic",
      "poi_latitude": "32.2209811",
      "poi_longitude": "-110.8783374",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 520-881-7387",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjxmLEcpx1oYRTw2mPx0yvx8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "veterinary_care"
    },
    {
      "id": "custom_19e5955c-f402-4c99-b93e-270b3b1524f5",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "V's Barbershop - Williams Centre",
      "poi_type": "Health and Wellness",
      "poi_address": "5420 E Broadway Blvd Suite 252, Tucson, AZ 85711, USA",
      "poi_short_description": "Classic barbershop offering haircuts, straight-razor shaves and beard trims, plus hot towels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-9d30-748c-b12f-ea48c93ee116.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-9d30-748c-b12f-ea48c93ee116",
        "storage_key": "property/6767906449166446/019d02cc-9d30-748c-b12f-ea48c93ee116.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4717033542932644736&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vs-barbershop---williams-centre",
      "poi_latitude": "32.2206925",
      "poi_longitude": "-110.8766769",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 520-203-7636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJezfEA79v1oYRgEMa8ANFdkE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_996ab3e6-e6b2-412d-84d0-890551d51d11",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Lighthouse/City YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "2900 N Columbus Blvd, Tucson, AZ 85712, USA",
      "poi_short_description": "Friendly staff at this gym featuring a clean pool, plus fitness classes, a weight room and child care.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-9d02-7369-b616-31d7002397e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-9d02-7369-b616-31d7002397e8",
        "storage_key": "property/6767906449166446/019d02cc-9d02-7369-b616-31d7002397e8.webp",
        "width": 1280,
        "height": 717
      },
      "poi_business_url": "https://tucsonymca.org/location/lighthousecity-ymca/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12075914827286826357&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lighthousecity-ymca",
      "poi_latitude": "32.262334",
      "poi_longitude": "-110.900383",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 520-795-9725",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo-0Ubh5u1oYRdc1N8o1Elqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_47eeb2fc-10ee-485d-9db2-e04ed998563d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Tucson Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "5301 E Grant Rd, Tucson, AZ 85712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-a047-73c9-946c-1cfa3499e3df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-a047-73c9-946c-1cfa3499e3df",
        "storage_key": "property/6767906449166446/019d02cc-a047-73c9-946c-1cfa3499e3df.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.tmcaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13715435122276979395&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tucson-medical-center",
      "poi_latitude": "32.2524759",
      "poi_longitude": "-110.8800722",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 520-327-5461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b60b-7718-bc73-15ba11caa34f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b60b-7718-bc73-15ba11caa34f",
        "storage_key": "property/6767906449166446/019d02cc-b60b-7718-bc73-15ba11caa34f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVxUjvjhu1oYRw1I8g5MDV74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_90ee8bd7-8ba9-4ea6-8861-13ad784fc6ea",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Specialists In Dermatology PLLC",
      "poi_type": "Health and Wellness",
      "poi_address": "2732 N Alvernon Way, Tucson, AZ 85712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-a01f-72f0-a829-4838b65af96c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-a01f-72f0-a829-4838b65af96c",
        "storage_key": "property/6767906449166446/019d02cc-a01f-72f0-a829-4838b65af96c.webp",
        "width": 1280,
        "height": 631
      },
      "poi_business_url": "https://www.specialistsindermatology.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17562066343654380870&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "specialists-in-dermatology-pllc",
      "poi_latitude": "32.2575685",
      "poi_longitude": "-110.9091399",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 520-382-3330",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b60b-7718-bc73-15ba11caa34f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b60b-7718-bc73-15ba11caa34f",
        "storage_key": "property/6767906449166446/019d02cc-b60b-7718-bc73-15ba11caa34f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVe9hMudx1oYRRtVcr0r-uPM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_7966282a-b085-4bc6-b633-a095d0da3944",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Sabino Canyon Recreation Area",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5700 N Sabino Canyon Rd, Tucson, AZ 85750, USA",
      "poi_short_description": "Desert canyon featuring hiking trails and waterfalls, plus a tram for a guided tour.",
      "poi_long_description": "People say this park offers beautiful scenery, hiking trails of varying difficulty, and a guided tram tour. They highlight the peaceful connection to nature, the well-maintained trails, and the informative audio program on the tram. They also like the convenient restrooms and the helpful staff at the visitor center. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-a2c5-755c-8f92-b650b84a3362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-a2c5-755c-8f92-b650b84a3362",
        "storage_key": "property/6767906449166446/019d02cc-a2c5-755c-8f92-b650b84a3362.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fs.usda.gov/recarea/coronado/recarea/?recid=75425",
      "poi_directions_map_url": "https://maps.google.com/?cid=15048779523884574601&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sabino-canyon-recreation-area",
      "poi_latitude": "32.3223645",
      "poi_longitude": "-110.8098631",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 520-749-8700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b64b-73ee-8d95-4708c0d8d865.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b64b-73ee-8d95-4708c0d8d865",
        "storage_key": "property/6767906449166446/019d02cc-b64b-73ee-8d95-4708c0d8d865.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJFSZgrHJs1oYRiedPwD4B2NA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_e864f536-0cc2-414d-8ece-023b5c469c30",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Tucson Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2150 N Alvernon Way, Tucson, AZ 85712, USA",
      "poi_short_description": "Tranquil sanctuary showcasing the region’s flora and fauna, along with a butterfly exhibition and cafe.",
      "poi_long_description": "People say this botanical garden offers a wide variety of cacti, succulents, flowers, and desert plants, as well as a butterfly exhibit, model train, and sculptures. They highlight the peaceful and tranquil vibe, and the well-maintained grounds with plenty of shade and benches. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-a29e-740f-b7c7-7e69b59c3343.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-a29e-740f-b7c7-7e69b59c3343",
        "storage_key": "property/6767906449166446/019d02cc-a29e-740f-b7c7-7e69b59c3343.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.tucsonbotanical.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2215348545925178451&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tucson-botanical-gardens",
      "poi_latitude": "32.248523",
      "poi_longitude": "-110.908785",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "2 hours 56 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 520-326-9686",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b64b-73ee-8d95-4708c0d8d865.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b64b-73ee-8d95-4708c0d8d865",
        "storage_key": "property/6767906449166446/019d02cc-b64b-73ee-8d95-4708c0d8d865.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJJfAWYdlx1oYRU2SM3cN_vh4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_cbb44e6e-170e-4cb0-bc43-f088487598d1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Agua Caliente Regional Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12325 E Roger Rd, Tucson, AZ 85749, USA",
      "poi_short_description": "Relaxing park featuring ponds, walking trails and a ranch house museum.",
      "poi_long_description": "People say this park offers beautiful ponds, walking trails, and picnic areas with grills, perfect for bird watching and enjoying nature. They highlight the peaceful and relaxing atmosphere, and the abundance of wildlife, including turtles, ducks, and fish. They also like the well-maintained facilities, including paved trails, benches, and clean restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-a485-776e-a8bc-d8b101ab3f8e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-a485-776e-a8bc-d8b101ab3f8e",
        "storage_key": "property/6767906449166446/019d02cc-a485-776e-a8bc-d8b101ab3f8e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.pima.gov/1244/Agua-Caliente-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=10143491054173849682&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "agua-caliente-regional-park",
      "poi_latitude": "32.281403",
      "poi_longitude": "-110.730285",
      "poi_miles_from_property": "9.3",
      "poi_walking_minutes": "3 hours 25 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "25 mins",
      "poi_business_phone": "+1 520-724-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b64b-73ee-8d95-4708c0d8d865.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b64b-73ee-8d95-4708c0d8d865",
        "storage_key": "property/6767906449166446/019d02cc-b64b-73ee-8d95-4708c0d8d865.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh_q378Np1oYRUohiCl_rxIw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8715ea33-d54d-4596-ac6c-c36aaf5ce539",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Brandi Fenton Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3482 E River Rd, Tucson, AZ 85718, USA",
      "poi_short_description": "Popular family-friendly park featuring a playground area and soccer fields, as well as a splash pad.",
      "poi_long_description": "People say this park offers multiple playgrounds, a splash pad, picnic areas, and a dog park. They highlight the clean and peaceful atmosphere, and the availability of amenities such as restrooms, ramadas, and a bike path. They also like the modern art sculptures and memorial garden. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-a5fc-737f-8d44-5b375af6508b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-a5fc-737f-8d44-5b375af6508b",
        "storage_key": "property/6767906449166446/019d02cc-a5fc-737f-8d44-5b375af6508b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.pima.gov/1321/Brandi-Fenton-Memorial-Park",
      "poi_directions_map_url": "https://maps.google.com/?cid=108679413455010454&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "brandi-fenton-memorial-park",
      "poi_latitude": "32.271999",
      "poi_longitude": "-110.917779",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 12 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 520-724-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b64b-73ee-8d95-4708c0d8d865.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b64b-73ee-8d95-4708c0d8d865",
        "storage_key": "property/6767906449166446/019d02cc-b64b-73ee-8d95-4708c0d8d865.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtaS1VvZx1oYRljpiyVkbggE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_eec1b74d-8d14-426d-bbbd-35ab6a849f0e",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "La Paloma Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3660 E Sunrise Dr, Tucson, AZ 85718, USA",
      "poi_short_description": "Elegant country club offering golf, tennis, a fitness club, a spa, a restaurant & an outdoor pool.",
      "poi_long_description": "People say this golf course offers a beautiful and well-maintained course with stunning views. They highlight the friendly and welcoming staff, and the private and well-maintained atmosphere. They also like the delicious food, plentiful breakfast buffet, and convenient shuttle service to a nearby mall.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-a888-7621-ba22-1e393d7338f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-a888-7621-ba22-1e393d7338f0",
        "storage_key": "property/6767906449166446/019d02cc-a888-7621-ba22-1e393d7338f0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.lapalomacc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15374346756569348809&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "la-paloma-country-club",
      "poi_latitude": "32.3172416",
      "poi_longitude": "-110.9157053",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 520-299-1500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-ba17-7081-ade7-0dcfcf403a14.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ba17-7081-ade7-0dcfcf403a14",
        "storage_key": "property/6767906449166446/019d02cc-ba17-7081-ade7-0dcfcf403a14.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJt87CzmJy1oYRybr-FuumXNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_f6b04dcf-d884-4a55-9001-e703a777f11d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "GEICO Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3050 S Martin Luther King Jr. Way, Tucson, AZ 85713, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-a7fd-71a9-ad93-5d3554a7d435.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-a7fd-71a9-ad93-5d3554a7d435",
        "storage_key": "property/6767906449166446/019d02cc-a7fd-71a9-ad93-5d3554a7d435.webp",
        "width": 964,
        "height": 1280
      },
      "poi_business_url": "https://www.geico.com/?y_source=1_MTQ5NTQ4NTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=17682928927373495645&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "geico-corporate-office",
      "poi_latitude": "32.2335795",
      "poi_longitude": "-110.8372864",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 520-546-5200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJKbtRzhBv1oYRXY2T2CtiZvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cc14f417-c0cf-46e7-947a-d4112c01d251",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Eastside City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7820 E Broadway Blvd, Tucson, AZ 85710, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-ab4e-74ff-b7a6-d3f6483c9ca7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-ab4e-74ff-b7a6-d3f6483c9ca7",
        "storage_key": "property/6767906449166446/019d02cc-ab4e-74ff-b7a6-d3f6483c9ca7.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7542542587844685258&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "eastside-city-hall",
      "poi_latitude": "32.2200573",
      "poi_longitude": "-110.8253884",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-ba52-76b8-b36e-c76efc993eea.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-ba52-76b8-b36e-c76efc993eea",
        "storage_key": "property/6767906449166446/019d02cc-ba52-76b8-b36e-c76efc993eea.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJlXrsTT1v1oYRyu28g4V-rGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_9f7a07a7-f410-4956-9a4d-8ae3f05a12d0",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Mt Lemmon SkyCenter Science Shop",
      "poi_type": "Major Employers & Offices",
      "poi_address": "8892 E Tanque Verde Rd, Tucson, AZ 85749, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-adbf-755e-a276-79aabd5365f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-adbf-755e-a276-79aabd5365f0",
        "storage_key": "property/6767906449166446/019d02cc-adbf-755e-a276-79aabd5365f0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://skycenterscienceshop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12050631344607424731&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mt-lemmon-skycenter-science-shop",
      "poi_latitude": "32.2574259",
      "poi_longitude": "-110.8028833",
      "poi_miles_from_property": "11.8",
      "poi_walking_minutes": "4 hours 16 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 520-626-8122",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK69V0r5p1oYR23CDZlxxPKc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a1480de5-89de-47f8-97f2-81342245a0ff",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "5870 E Broadway Blvd Suite 442, Tucson, AZ 85711",
      "poi_short_description": "Cosmetics retailer with makeup, haircare and skincare products.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "130",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f1b31e1c-e150-4c40-8093-8a677a734627",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Fruchthendler Elementary School",
      "poi_type": "Education",
      "poi_address": "7470 E Cloud Rd, Tucson, AZ 85750",
      "poi_short_description": "Zoned TUSD elementary school for the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0780478f-0b27-4042-b089-5594b2375ff3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Joseph W. Magee Middle School",
      "poi_type": "Education",
      "poi_address": "8300 E Speedway Blvd, Tucson, AZ 85710",
      "poi_short_description": "Zoned TUSD middle school for the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "120",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bca8ad50-672f-42bf-aad4-8aa5f698c969",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Sabino High School",
      "poi_type": "Education",
      "poi_address": "5000 N Bowes Rd, Tucson, AZ 85749",
      "poi_short_description": "Zoned TUSD high school for the community.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "90",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b923aeac-d223-41b3-8232-bbf4a820b8b7",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Catalina Foothills",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Coronado National Forest, Catalina Hwy, Tucson, AZ 85750",
      "poi_short_description": "Scenic foothills of the Santa Catalina Mountains.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "60",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4a912f77-028d-4296-899d-69d234b248c9",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Sun Tran Route 8 - Broadway",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sabino Canyon Rd & Tanque Verde Rd, Tucson, AZ 85715",
      "poi_short_description": "Nearest Sun Tran bus route, serving the Broadway corridor.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2465d719-c03f-473f-8942-89c4cf3e9880",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Sun Tran Route 5 - Pima/Speedway",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sabino Canyon Rd & Tanque Verde Rd, Tucson, AZ 85715",
      "poi_short_description": "NE-side Sun Tran bus route to central Tucson.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "30",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_34fc74b4-29c1-4e43-9c9a-f59489c7c870",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Sun Tran Route 9 - Grant",
      "poi_type": "Transportation & Transit",
      "poi_address": "Sunrise Dr & Kolb Rd, Tucson, AZ 85750",
      "poi_short_description": "Sun Tran route serving the Sabino/Sunrise area.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "40",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7f6d17ac-facb-46b1-87e0-19fbd431a461",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Udall Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "7200 E Tanque Verde Rd, Tucson, AZ 85715",
      "poi_short_description": "Northeast-side Sun Tran transit hub.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "50",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bc713088-816c-413a-8acf-57313e39e857",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Ronstadt Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "215 E Congress St, Tucson, AZ 85701",
      "poi_short_description": "Main downtown Sun Tran transit hub.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "12",
      "poi_walking_minutes": "240",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_065a0b70-6dc4-4bf8-8e1a-b92b4b863580",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Tucson International Airport (TUS)",
      "poi_type": "Transportation & Transit",
      "poi_address": "7250 S Tucson Blvd, Tucson, AZ 85756",
      "poi_short_description": "Regional commercial airport.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "18",
      "poi_walking_minutes": "360",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2f1eb00b-2f2c-423d-8a22-191d3e8643c1",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "University of Arizona",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1401 E University Blvd, Tucson, AZ 85721",
      "poi_short_description": "Major university and one of Tucson's largest employers.",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "",
      "poi_item_slug": "false",
      "poi_latitude": "",
      "poi_longitude": "",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "160",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "",
      "poi_day_night_filter": "",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_fae40511-f650-4cb5-8970-96a23b9d2b07",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Tucson Desert Art Museum and Four Corners Gallery",
      "poi_type": "Entertainment",
      "poi_address": "7000 E Tanque Verde Rd, Tucson, AZ 85715, USA",
      "poi_short_description": "Native American textiles & artifacts share space with contemporary paintings at this desert museum.",
      "poi_long_description": "Visitors say this art museum offers a captivating journey through history, showcasing artifacts, beautiful jewelry, and thought-provoking photography. They also highlight the museum's well-curated exhibits, which blend art, craft, and culture to provide a unique and engaging experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f0aed-bee8-7799-bc81-1935259b5ee7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f0aed-bee8-7799-bc81-1935259b5ee7",
        "storage_key": "property/6767906449166446/019f0aed-bee8-7799-bc81-1935259b5ee7.webp",
        "width": 1219,
        "height": 1280
      },
      "poi_business_url": "http://www.tucsondart.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12463099601681588940&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tucson-desert-art-museum-and-four-corners-gallery",
      "poi_latitude": "32.2499577",
      "poi_longitude": "-110.8418409",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-202-3888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5e5-71c1-8a49-451b98b8860e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5e5-71c1-8a49-451b98b8860e",
        "storage_key": "property/6767906449166446/019d02cc-b5e5-71c1-8a49-451b98b8860e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTbyQuNu1oYRzCKLLg7T9aw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_7d436c2d-8fab-4022-bde5-7b83219b489c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Tucson Country Club",
      "poi_type": "Entertainment",
      "poi_address": "2950 N Camino Principal, Tucson, AZ 85715, USA",
      "poi_short_description": "Membership-only club with a golf course, a pool and dining.",
      "poi_long_description": "Visitors say this country club offers a traditional golf course, tennis courts, and a swimming pool, all set within a beautiful, well-maintained environment. They also highlight the welcoming and friendly atmosphere, with staff and members creating a strong sense of camaraderie. Guests mention the excellent food and decor, especially during special events and holiday celebrations.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f4944-06a5-719a-8090-a7e9a6e619dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f4944-06a5-719a-8090-a7e9a6e619dd",
        "storage_key": "property/6767906449166446/019f4944-06a5-719a-8090-a7e9a6e619dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.tucsoncountryclub.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14044857567506851920&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tucson-country-club",
      "poi_latitude": "32.261063299999996",
      "poi_longitude": "-110.85134599999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-298-2381",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYSTRf19u1oYRUOgzeItb6cI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_a156fcc1-8819-42be-8bb9-7d6775d3c718",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Davis-Monthan AFB",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Craycroft Rd, Tucson, AZ 85707, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f4944-06a8-751d-a7df-e24211b9195c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f4944-06a8-751d-a7df-e24211b9195c",
        "storage_key": "property/6767906449166446/019f4944-06a8-751d-a7df-e24211b9195c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.dm.af.mil/About-DM/Base-Access/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7633698599262041136&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "davis-monthan-afb---visitors-center",
      "poi_latitude": "32.1907536",
      "poi_longitude": "-110.8755299",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "+1 520-228-0135",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7x3RSaJl1oYRMDRpU25Y8Gk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "visitor_center"
    },
    {
      "id": "custom_454336ba-72bb-450c-91c2-1a3a9e0bda28",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Raytheon",
      "poi_type": "Major Employers & Offices",
      "poi_address": "9000 S Rita Rd, Tucson, AZ 85747, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f4944-07b4-7001-b918-cb5d079aaa0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019f4944-07b4-7001-b918-cb5d079aaa0e",
        "storage_key": "property/6767906449166446/019f4944-07b4-7001-b918-cb5d079aaa0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.raytheon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6978800583857042279&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "raytheon",
      "poi_latitude": "32.0951215",
      "poi_longitude": "-110.8084424",
      "poi_miles_from_property": "16.6",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b5be-7054-a039-90e956eaf73a",
        "storage_key": "property/6767906449166446/019d02cc-b5be-7054-a039-90e956eaf73a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJD17dIGJh1oYRZ3MW3yeu2WA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_a212feea-1a12-46ea-bd66-e5fe0248815c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "poi_name": "Tucson Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5301 E Grant Rd, Tucson, AZ 85712, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-a047-73c9-946c-1cfa3499e3df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d02cc-a047-73c9-946c-1cfa3499e3df",
        "storage_key": "property/6767906449166446/019d02cc-a047-73c9-946c-1cfa3499e3df.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.tmcaz.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13715435122276979395&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tucson-medical-center",
      "poi_latitude": "32.2524759",
      "poi_longitude": "-110.8800722",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "",
      "poi_driving_minutes": "",
      "poi_business_phone": "+1 520-327-5461",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019d02cc-b60b-7718-bc73-15ba11caa34f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d02cc-b60b-7718-bc73-15ba11caa34f",
        "storage_key": "property/6767906449166446/019d02cc-b60b-7718-bc73-15ba11caa34f.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJVxUjvjhu1oYRw1I8g5MDV74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    }
  ],
  "office_hours": [
    {
      "id": "ec_05247cc05ab13ba8f83e499c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_21a235e510f639c585b3c5cc",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_9962de2949ad74ffe449033f",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_db2fa38e1c593a9771f9b5d3",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2ad08f5f254e712ea442ddda",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_2bc830e390ee026915809fa7",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_aae2f581-876a-49c5-8c55-aee74ecd62fc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "rating": "5.0",
      "name": "Jordan Frett",
      "text": "We had such a wonderful experience on our apartment tour thanks to Araceli. She was professional, friendly, and extremely knowledgeable about the property and surrounding area. She took the time to answer all of our questions in detail and made sure we felt comfortable and informed throughout the entire tour. Her positive attitude and genuine enthusiasm really stood out and made the process enjoyable. We left the tour with a clear understanding of the community and a great impression thanks to her!",
      "date": "2025-08-24",
      "title": ""
    },
    {
      "id": "custom_b82f803e-4d6f-42b0-af9c-ed6ab9fd7272",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "rating": "5.0",
      "name": "Juan Parra",
      "text": "Always great service with pinnacle heights apartments. I had an issue with my air conditioning, And they quickly came out that same day and repair it , also took care of another issue that I had with a light Switch. The young Maintenance man,  Is always courteous and very efficient at what what he does. Happy Tenant.\n\nHighly recommend pinnacle heights, apartments. Look at these beautiful views.",
      "date": "2024-06-12",
      "title": ""
    },
    {
      "id": "custom_b9f20d9d-fab0-4521-9923-61b75ed350bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "rating": "5.0",
      "name": "Chris F",
      "text": "I lived at pinnacle Heights for 3 years I moved to Tucson from St. Louis. So it was definitely a huge move for me. When I was looking around  pinnacle heights was the only apartment complex that caught my eyes! It’s a gorgeous with great amenities. The staff was wonderful and always made me feel welcome. If my job ever moves me back to Tucson this will be the place I would choose to live at again!",
      "date": "2025-09-09",
      "title": ""
    },
    {
      "id": "custom_32ac353c-e8f7-4b8a-bca3-52ec938c9646",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "rating": "5.0",
      "name": "Rebecca Ann",
      "text": "Love, love, love this complex!! Today, though I just wanted to take a second to thank Zachery from the maintenance team!! I sent a message over the holiday weekend about a light being out in my kitchen and mentioned that I wouldn’t be available until 10am today. HE WAS AT THE DOOR AT EXACTLY 10AM! And he’s honestly just the kindest! He’s been excellent any time we’ve needed anything! So big, big thank you to Zach!!",
      "date": "2025-09-02",
      "title": ""
    },
    {
      "id": "custom_ff792eb2-ad44-4246-97c6-7a757e220e6b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "rating": "5.0",
      "name": "Emily J",
      "text": "I was a resident at Pinnacle Heights Apartments from February 2020, until my husband recently accepted a job in Phoenix, and I truly loved my time living here.\n\nFrom day one, the customer service was outstanding. Monica, the manager, was always warm, professional, and genuinely cared about the residents. She consistently went above and beyond to make sure everything ran smoothly in the community. Hadi and Anaya were always welcoming and attentive to our needs. Any time my husband and I had a concern, they did everything in their power to ensure that our issues were resolved quickly.\n\nThe maintenance team was also top-notch. Every repair request was handled promptly and thoroughly. Zach, in particular, was always friendly, reliable, and incredibly hard-working. He made sure any issues were taken care of quickly and efficiently.\n\nLeaving Pinnacle Heights was bittersweet — the only reason we moved was due to a job relocation. If I ever have the chance to return, I would do so in a heartbeat. I highly recommend Pinnacle Heights to anyone looking for a well-managed, welcoming place to call home.",
      "date": "2025-06-22",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_3fa593bd-94a0-48ef-aba5-5bd760e3a0e8",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f6c18-859b-708d-aace-e5b490592cbb.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-859b-708d-aace-e5b490592cbb",
        "storage_key": "property/6767906449166446/019f6c18-859b-708d-aace-e5b490592cbb.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Community Tour | Social Lounge",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=MBvzCxxMxZW"
    },
    {
      "id": "custom_537df787-063e-4f53-9227-236f27de844d",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f6c18-861c-7376-954e-d28ef8358752.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-861c-7376-954e-d28ef8358752",
        "storage_key": "property/6767906449166446/019f6c18-861c-7376-954e-d28ef8358752.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Community Tour | Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=5adc2tTuF3g"
    },
    {
      "id": "custom_d6ab704e-50c8-4ae4-b4a9-64ef0fbf00ac",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f6c18-8794-7163-92ea-f7827c605912.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-8794-7163-92ea-f7827c605912",
        "storage_key": "property/6767906449166446/019f6c18-8794-7163-92ea-f7827c605912.webp",
        "width": 1916,
        "height": 914
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1,158SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=sSJEPskmZPC&play=1"
    },
    {
      "id": "custom_85d2c107-229f-45c2-87ee-2ecf64025bcb",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f6c18-87a1-75dc-85b1-9ea90a6927c8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-87a1-75dc-85b1-9ea90a6927c8",
        "storage_key": "property/6767906449166446/019f6c18-87a1-75dc-85b1-9ea90a6927c8.webp",
        "width": 1919,
        "height": 913
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1,152SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=hwgQyCiyaWw&play=1"
    },
    {
      "id": "custom_1711e68e-8461-44ce-af04-989df0ab2a1c",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f6c18-8830-718a-8ccb-9ad1ca087d1e.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-8830-718a-8ccb-9ad1ca087d1e",
        "storage_key": "property/6767906449166446/019f6c18-8830-718a-8ccb-9ad1ca087d1e.webp",
        "width": 1920,
        "height": 914
      },
      "virtual_tour_title": "Apartment Tour | 1BR, 1BA | 863SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=GthwYnq8Lzs&play=1"
    },
    {
      "id": "custom_cbf9a81b-c389-4058-bf6d-cc25853fe6b3",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166446/019f6c18-85b3-71f6-954f-3e0e3ddc9834.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f6c18-85b3-71f6-954f-3e0e3ddc9834",
        "storage_key": "property/6767906449166446/019f6c18-85b3-71f6-954f-3e0e3ddc9834.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Apartment Tour | 2 BR, 2 BA | 1158 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=dVNXxXYy3mo"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "0199dff0-5705-710c-be84-a9f3d8f9ded8",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "amc-pinnacle-heights-auto",
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "resort-style-pool-apartments-tucson",
      "search_query": "resort style pool apartments tucson",
      "category": "Amenity",
      "h1_title": "Resort Style Pool Apartments in Tucson",
      "h2_subtitle": "Discover resort-style living with a refreshing pool right at Pinnacle Heights. Offering the best in Tucson with luxurious amenities and stunning views.",
      "page_copy": "Welcome to Pinnacle Heights, where the charm of Tucson meets luxury living. Our resort style pool apartments provide a relaxing retreat with stunning mountain views. At Pinnacle Heights, you can unwind at our tranquil pool area or enjoy the relaxing clubhouse and coffee bar. Whether you prefer swimming under the clear Arizona sky or soaking up the sun at our spacious pool deck, our community offers the perfect backdrop for leisure and relaxation.\n\nLocated in the scenic Sabino Terrace neighborhood, Pinnacle Heights combines convenience with upscale living. Our state-of-the-art fitness center and large walk-in closets offer both comfort and practicality. With E-STAR stainless steel appliances and wood burning fireplaces in select units, experience the ultimate resort-style lifestyle in the heart of Tucson. Choose Pinnacle Heights for a remarkable home that meets all of your lifestyle needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool Apartments in Tucson",
      "seo_description": "Experience resort-style living with a pool at Pinnacle Heights, Tucson. Enjoy luxurious amenities in our spacious apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "apartments-in-unit-laundry-sabino-terrace",
      "search_query": "apartments with in-unit laundry sabino terrace",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Sabino Terrace",
      "h2_subtitle": "Enjoy the convenience of in-unit laundry at Pinnacle Heights. Nestled in Sabino Terrace, we offer modern amenities for a seamless lifestyle.",
      "page_copy": "Discover the ease of everyday living at Pinnacle Heights. Our apartments with in-unit laundry located in the desirable Sabino Terrace neighborhood offer practical convenience without sacrificing luxury. Each unit reflects modern living standards with features like large walk-in closets, perfect for organizing all your essentials, and spacious areas for a comfortable lifestyle.\n\nSituated in Tucson's picturesque setting, Pinnacle Heights provides not only the convenience of in-unit laundry but also top-notch amenities. Our E-STAR stainless steel appliances, complemented by stunning views and state-of-the-art fitness center, make daily living a pleasure. Enjoy the tranquil environment at Pinnacle Heights, where amenities like our relaxing clubhouse with a coffee bar add an extra layer of comfort to your lifestyle.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments in Sabino Terrace",
      "seo_description": "Find your perfect home at Pinnacle Heights with in-unit laundry and modern amenities in Sabino Terrace, Tucson.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "mountain-view-apartments-tucson-az",
      "search_query": "mountain view apartments tucson az",
      "category": "Amenity",
      "h1_title": "Mountain View Apartments in Tucson, AZ",
      "h2_subtitle": "Pinnacle Heights offers stunning mountain view apartments in Tucson, AZ. Relish in breathtaking vistas and top-tier amenities.",
      "page_copy": "Embrace the beauty of Tucson living at Pinnacle Heights. Our mountain view apartments capture the essence of Arizona's natural landscapes. Nestled in Tucson, AZ, Pinnacle Heights offers panoramic views that perfectly blend comfort and serenity. Our community delivers an exceptional living environment with spacious layouts and features like E-STAR stainless steel appliances and large walk-in closets.\n\nSet in the beautiful Sabino Terrace neighborhood, Pinnacle Heights isn't just about views. Enjoy resort-style amenities such as a refreshing pool and a fitness center. Relax by your wood burning fireplace after a day of exploring Tucson's breathtaking surroundings. At Pinnacle Heights, you experience remarkable views and unparalleled comfort, making everyday living special.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Mountain View Apartments in Tucson, AZ",
      "seo_description": "Discover Pinnacle Heights in Tucson, AZ, for stunning mountain view apartments with luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "detached-garage-apartments-near-85750",
      "search_query": "detached garage apartments near 85750",
      "category": "Amenity",
      "h1_title": "Detached Garage Apartments Near 85750",
      "h2_subtitle": "Explore Pinnacle Heights for apartments near 85750 with the advantage of detached garages. Enjoy modern living in a prime location.",
      "page_copy": "Find your next home at Pinnacle Heights, where convenience meets modern living just near the 85750 area code. Our apartments with detached garages offer the perfect solution for those seeking both space and security for their vehicles. Located in the beautiful Sabino Terrace neighborhood, each apartment is designed with your lifestyle in mind, featuring spacious interiors and large walk-in closets.\n\nPinnacle Heights provides more than just essential amenities. Enjoy access to a state-of-the-art fitness center, a calming clubhouse, and E-STAR stainless steel appliances in our well-appointed apartments. With the added benefit of a detached garage, you can enjoy all the qualities of a premier community while being conveniently close to Tucson's shopping and outdoor attractions.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Detached Garage Apartments Near 85750",
      "seo_description": "Discover Pinnacle Heights' apartments with detached garages near 85750. Offering convenient and modern living in a prime Tucson location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "state-of-the-art-fitness-center-apartments-pima-county",
      "search_query": "apartments with state-of-the-art fitness center pima county",
      "category": "Amenity",
      "h1_title": "Apartments with Fitness Center in Pima County",
      "h2_subtitle": "Pinnacle Heights in Pima County boasts a state-of-the-art fitness center. Experience health-focused living with premier amenities.",
      "page_copy": "Experience the ultimate in health-oriented living at Pinnacle Heights, located in beautiful Pima County. Our apartments feature a state-of-the-art fitness center, ensuring you have the best facilities at your doorstep. Nestled in the serene Sabino Terrace neighborhood, our community combines relaxation with modern convenience, offering luxurious amenities like E-STAR stainless steel appliances and spacious floor plans.\n\nEnhance your wellbeing with our on-site fitness options while savoring the additional comforts of our community, such as a relaxing clubhouse complete with a coffee bar. At Pinnacle Heights, every detail is designed to promote a balanced lifestyle and elevate your living experience in the heart of Tucson.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Fitness Center in Pima County",
      "seo_description": "Discover Pinnacle Heights in Pima County, featuring apartments with a state-of-the-art fitness center and luxurious amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-sabino-terrace-tucson",
      "search_query": "1 bedroom apartments in Sabino Terrace Tucson",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Sabino Terrace, Tucson",
      "h2_subtitle": "Pinnacle Heights offers charming 1 bedroom apartments in Sabino Terrace, Tucson. Enjoy modern amenities and excellent community features.",
      "page_copy": "Discover the perfect blend of comfort and convenience at Pinnacle Heights, offering stylish 1 bedroom apartments in the charming Sabino Terrace neighborhood of Tucson. Our thoughtfully designed units provide a peaceful retreat with features like E-STAR stainless steel appliances and large walk-in closets. Enjoy the sophisticated ambiance of a wood burning fireplace, perfect for cozy evenings at home.\n\nAs a resident of Pinnacle Heights, take advantage of our premier amenities including a state-of-the-art fitness center and a relaxing clubhouse with a coffee bar. Situated in Pima County, our community provides easy access to Tucson's vibrant cultural attractions and natural beauty, making it an ideal location for both work and play. Experience quality living right at your doorstep!",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in Sabino Terrace, Tucson",
      "seo_description": "Explore 1 bedroom apartments at Pinnacle Heights in Sabino Terrace, Tucson. Enjoy modern amenities and a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-85750",
      "search_query": "2 bedroom apartments near 85750",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near 85750",
      "h2_subtitle": "Find spacious 2 bedroom apartments near 85750 at Pinnacle Heights. Located in a vibrant community with amenities that enhance modern living.",
      "page_copy": "Welcome to Pinnacle Heights, where you’ll find spacious 2 bedroom apartments perfectly situated near the 85750 area code. Each apartment is thoughtfully designed to provide ample living space, modern features like E-STAR stainless steel appliances, and luxurious touches like large walk-in closets and wood burning fireplaces.\n\nEnjoy living in the serene Sabino Terrace neighborhood while benefiting from exceptional community amenities. Whether you're relaxing in our clubhouse with a coffee bar or staying fit in our state-of-the-art fitness center, Pinnacle Heights offers the ideal blend of comfort and convenience. Close to Tucson's beautiful landscapes and thriving local scene, this is the perfect place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near 85750",
      "seo_description": "Discover spacious 2 bedroom apartments near 85750 at Pinnacle Heights. Enjoy modern living and outstanding community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "3-bedroom-apartments-pima-county-az",
      "search_query": "3 bedroom apartments in Pima County AZ",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Apartments in Pima County, AZ",
      "h2_subtitle": "Explore 3 bedroom apartments at Pinnacle Heights, located in Pima County, AZ. Experience premium living with modern amenities and a welcoming community.",
      "page_copy": "At Pinnacle Heights, we offer expansive 3 bedroom apartments in the heart of Pima County, AZ. Each unit is designed to provide an open and comfortable living environment, equipped with modern amenities like E-STAR stainless steel appliances and large walk-in closets. Our apartments also feature beautiful wood burning fireplaces, perfect for creating a cozy atmosphere.\n\nNestled in the peaceful Sabino Terrace neighborhood, our community provides easy access to Tucson's popular attractions while maintaining a serene living experience. Enjoy the benefits of a state-of-the-art fitness center and a stylish clubhouse with a coffee bar, ensuring a well-rounded lifestyle. Come home to Pinnacle Heights, where luxury and convenience meet.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Apartments in Pima County, AZ",
      "seo_description": "Find spacious 3 bedroom apartments at Pinnacle Heights in Pima County, AZ. Enjoy premium amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "apartments-near-pima-medical-institute-tucson",
      "search_query": "apartments near Pima Medical Institute Tucson Sabino Terrace",
      "category": "School",
      "h1_title": "Apartments Near Pima Medical Institute Tucson",
      "h2_subtitle": "Discover apartments near Pima Medical Institute in Tucson's Sabino Terrace. Find convenience and comfort at Pinnacle Heights.",
      "page_copy": "Pinnacle Heights offers the ideal location for students and professionals looking for apartments near Pima Medical Institute Tucson, nestled in the serene Sabino Terrace area. Our community provides easy access to educational opportunities while offering a peaceful retreat at the end of the day. With E-STAR stainless steel appliances and large walk-in closets, our apartments provide a modern and comfortable living experience.\n\nResidents at Pinnacle Heights enjoy top-tier amenities, including a state-of-the-art fitness center and a cozy clubhouse complete with a coffee bar. Experience the best of both worlds with a short commute to Pima Medical Institute and the vibrant lifestyle of Tucson. Live close to where you learn while enjoying all that Pinnacle Heights has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Pima Medical Institute Tucson",
      "seo_description": "Find comfortable apartments near Pima Medical Institute in Tucson, Sabino Terrace. Enjoy modern amenities at Pinnacle Heights.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "apartments-near-tucson-medical-center-az",
      "search_query": "apartments near tucson medical center az",
      "category": "Hospital",
      "h1_title": "Apartments Near Tucson Medical Center, AZ",
      "h2_subtitle": "Find comfortable apartments near Tucson Medical Center in AZ at Pinnacle Heights. Experience modern living with convenient amenities.",
      "page_copy": "At Pinnacle Heights, we present ideal living options for those seeking apartments near Tucson Medical Center, AZ. Our community is perfectly placed to offer easy commutes, providing the convenience of nearby healthcare access and the tranquility of a home retreat. Each apartment is designed with modern features, from E-STAR stainless steel appliances to large walk-in closets, catering to the needs of our residents.\n\nNestled in the serene Sabino Terrace neighborhood, Pinnacle Heights offers more than just a prime location. Enjoy amenities like a relaxing clubhouse with a coffee bar and a state-of-the-art fitness center. Live life comfortably and efficiently in Tucson, where home is both a sanctuary and an accessible gateway to all the city has to offer.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tucson Medical Center, AZ",
      "seo_description": "Discover comfortable apartments near Tucson Medical Center, AZ at Pinnacle Heights. Enjoy modern living with convenient amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "apartments-near-specialists-in-dermatology-sabino-terrace",
      "search_query": "apartments close to specialists in dermatology PLLC sabino terrace",
      "category": "Hospital",
      "h1_title": "Apartments Close to Specialists in Dermatology",
      "h2_subtitle": "Explore apartments close to Specialists in Dermatology PLLC in Sabino Terrace. Enjoy convenient living at Pinnacle Heights.",
      "page_copy": "If you're looking for apartments close to Specialists in Dermatology PLLC in the Sabino Terrace area, Pinnacle Heights offers an exceptional living choice. Our community gives you the convenience of a short commute to dermatological care while ensuring a serene and modern living environment. Our well-designed apartments come equipped with E-STAR stainless steel appliances and spacious walk-in closets.\n\nPinnacle Heights is more than a convenient location; it’s a haven with amenities like a state-of-the-art fitness center and a welcoming clubhouse that features a coffee bar. Experience a lifestyle where accessibility meets luxury, providing a perfect blend of comfort and practicality for healthcare professionals and patients alike in Tucson.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Specialists in Dermatology",
      "seo_description": "Find apartments near Specialists in Dermatology PLLC in Sabino Terrace at Pinnacle Heights. Experience convenient and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "apartments-near-sabino-canyon-recreation-area-tucson",
      "search_query": "apartments near sabino canyon recreation area tucson",
      "category": "Park",
      "h1_title": "Apartments Near Sabino Canyon Recreation Area",
      "h2_subtitle": "Discover apartments near Sabino Canyon Recreation Area in Tucson at Pinnacle Heights. Enjoy nature and modern amenities close to home.",
      "page_copy": "Embrace the beauty of Tucson with Pinnacle Heights, offering unparalleled proximity to the breathtaking Sabino Canyon Recreation Area. Our apartments provide the perfect base for nature enthusiasts seeking convenient access to one of the city's most scenic outdoor destinations. Each residence is thoughtfully equipped with features like E-STAR stainless steel appliances and expansive walk-in closets, ensuring both style and functionality.\n\nLocated in the tranquil Sabino Terrace neighborhood, Pinnacle Heights complements its natural surroundings with luxury amenities such as a relaxing clubhouse with coffee bar and a state-of-the-art fitness center. Residents can enjoy the adventure of Sabino Canyon while seamlessly blending it with the comforts of modern living. Explore hiking trails by day and relax by your wood-burning fireplace by night at Pinnacle Heights.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sabino Canyon Recreation Area",
      "seo_description": "Discover comfortable living near Sabino Canyon Recreation Area at Pinnacle Heights, Tucson. Enjoy modern amenities and nature's beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "pinnacle-heights-near-tucson-botanical-gardens",
      "search_query": "pinnacle heights close to tucson botanical gardens",
      "category": "Park",
      "h1_title": "Pinnacle Heights Close to Tucson Botanical Gardens",
      "h2_subtitle": "Live near Tucson Botanical Gardens at Pinnacle Heights. Enjoy the convenience of nearby natural beauty and modern amenities.",
      "page_copy": "Pinnacle Heights is ideally located for residents who appreciate the lush, serene beauty of the Tucson Botanical Gardens. Situated within a short drive, our apartment community offers the perfect blend of proximity to nature with urban convenience. Each apartment features spacious layouts with large walk-in closets and modern E-STAR stainless steel appliances that add a touch of luxury to everyday living.\n\nEnjoy the benefits of residential life in Sabino Terrace with Pinnacle Heights. We provide amenities such as a state-of-the-art fitness center and a relaxing clubhouse with a coffee bar, ensuring both convenience and relaxation. With Tucson Botanical Gardens nearby, you can easily take in the beauty of curated gardens, immersing yourself in Tucson's rich flora while retreating to the comfort and luxury of your Pinnacle Heights home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pinnacle Heights Near Tucson Botanical Gardens",
      "seo_description": "Discover Pinnacle Heights near Tucson Botanical Gardens. Enjoy modern living with convenient access to lush, natural beauty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "apartments-near-agua-caliente-regional-park-sabino-terrace",
      "search_query": "apartments near agua caliente regional park sabino terrace",
      "category": "Park",
      "h1_title": "Apartments Near Agua Caliente Regional Park",
      "h2_subtitle": "Find perfect apartments near Agua Caliente Regional Park in Sabino Terrace. Pinnacle Heights offers nature close to home.",
      "page_copy": "Nestled within the serene Sabino Terrace, Pinnacle Heights provides luxury living opportunities just moments away from the spectacular Agua Caliente Regional Park. Our community is perfect for those who love enjoying the outdoors without sacrificing the conveniences of modern apartment features. Relax in spacious apartments with amenities like large walk-in closets and top-of-the-line E-STAR stainless steel appliances.\n\nBeyond the allure of nearby natural settings, Pinnacle Heights offers residents state-of-the-art community features including a well-equipped fitness center and a warm, inviting clubhouse complete with a cozy coffee bar. Whether you're returning from a day of adventure in Agua Caliente Park or simply savoring a peaceful evening by the wood-burning fireplace, our apartments promise a lifestyle steeped in comfort and convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Agua Caliente Regional Park",
      "seo_description": "Live near Agua Caliente Regional Park at Pinnacle Heights. Experience Tucson's natural beauty and modern amenities in Sabino Terrace.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5742705921490944",
      "property_id": "6767906449166446",
      "source": "generator",
      "page_item_url": "pinnacle-heights-near-brandi-fenton-memorial-park",
      "search_query": "pinnacle heights close to brandi fenton memorial park pima county",
      "category": "Park",
      "h1_title": "Pinnacle Heights Close to Brandi Fenton Park",
      "h2_subtitle": "Pinnacle Heights offers comfort and style near Brandi Fenton Memorial Park in Pima County. Enjoy local culture and community activities.",
      "page_copy": "Experience modern living at Pinnacle Heights, located a convenient drive away from the vibrant Brandi Fenton Memorial Park in Pima County. Our community offers residents the perfect blend of active lifestyle opportunities and luxurious home comfort. With expansive layout options featuring large walk-in closets and E-STAR stainless steel appliances, our apartments cater to those who appreciate quality and functionality.\n\nLocated in the peaceful Sabino Terrace area, Pinnacle Heights compliments its lush surroundings with advanced amenities like a state-of-the-art fitness center and a cozy clubhouse with a coffee bar. Whether you're exploring the diverse recreational offerings at Brandi Fenton Park or relaxing at home by a warm, wood-burning fireplace, Pinnacle Heights is designed to provide an exceptional living experience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pinnacle Heights Near Brandi Fenton Memorial Park",
      "seo_description": "Discover Pinnacle Heights near Brandi Fenton Memorial Park, Pima County. Enjoy luxury living with access to local culture and recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5318"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18104425177"
    },
    {
      "ID": "custom_lea_chatbot",
      "type": "STRING",
      "value": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=2f6c9e9caa4c3ff92d92e4bbcc722163b3af97bc84c6317c19a305b967c10d007a229628909e60b6e887d72f9e4d930f\"></script>"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-T9DBWC33"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Milburn"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Milburn Homestead"
    },
    {
      "ID": "custom_aim_property_code",
      "type": "STRING",
      "value": "94PHT"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "40254249088"
    },
    {
      "ID": "custom_broker_license_number",
      "type": "STRING",
      "value": "BR573712000"
    },
    {
      "ID": "custom_anyonehome_scheduler_url",
      "type": "STRING",
      "value": "https://www.myshowing.com/AMC LLC/Pinnacle Heights/scheduletourwidget/alW2WcxJ37ES5aHvgY/"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImtYQW95U0NKLzBFSSs1TlAwcWkwaGc9PSIsInZhbHVlIjoiUWxTY3JPZFlJYUVwVFFoN0JmdDNRdz09IiwibWFjIjoiZTdmMGJhMjgxMWZmNTAyNDJkYTdmNzVkMjhlMDdkMDk1ZTUwNzI2NjIyMmY3N2FhMjRmZWIxMWI1NTAzNzExYyJ9"
    }
  ],
  "custom_qb_id": "5318",
  "custom_repli_id": "18104425177",
  "custom_lea_chatbot": "<script src=\"https://ai-chat-frontend.lea.ai/api/embed?pid=2f6c9e9caa4c3ff92d92e4bbcc722163b3af97bc84c6317c19a305b967c10d007a229628909e60b6e887d72f9e4d930f\"></script>",
  "custom_google_gtm_id": "GTM-T9DBWC33",
  "custom_rollout_phase": "Milburn",
  "custom_vibesites_theme": "Milburn Homestead",
  "custom_aim_property_code": "94PHT",
  "custom_hubspot_company_id": "40254249088",
  "custom_broker_license_number": "BR573712000",
  "custom_anyonehome_scheduler_url": "https://www.myshowing.com/AMC LLC/Pinnacle Heights/scheduletourwidget/alW2WcxJ37ES5aHvgY/",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImtYQW95U0NKLzBFSSs1TlAwcWkwaGc9PSIsInZhbHVlIjoiUWxTY3JPZFlJYUVwVFFoN0JmdDNRdz09IiwibWFjIjoiZTdmMGJhMjgxMWZmNTAyNDJkYTdmNzVkMjhlMDdkMDk1ZTUwNzI2NjIyMmY3N2FhMjRmZWIxMWI1NTAzNzExYyJ9",
  "custom_audioeye_site_id": "cd6ffe11-fa80-48fc-b1ce-e2add974bdea",
  "custom_audioeye_site_hash": "23a4ca13ca8414ecc76d534f92d13383"
};

export const generatedAt = '2026-08-24T16:58:38.986Z';
